<template>
  <section class="dp-layout">
    <section class="dp-right">
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

    <!--列表-->
    <div class="tbl-scroll-host">
    <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" row-key="Id"
      border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" class="custom-tbl"
      height="100%" style="width: 100%" ref="table">
      <el-table-column type="selection" width="48" align="center"></el-table-column>
      <el-table-column prop="OrderSort" label="序号" width="56" align="center"></el-table-column>
      <!-- 长 ID：固定最小宽 + 省略，避免撑高行。最后修改：2026-09-13 -->
      <el-table-column prop="Id" label="机构标识" min-width="150" show-overflow-tooltip class-name="col-mono"></el-table-column>
      <el-table-column prop="Name" label="机构名称" min-width="140" show-overflow-tooltip></el-table-column>

      <el-table-column prop="Logo" label="Logo" width="72" align="center" header-align="center">
        <template slot-scope="scope">
          <oss-media-thumbs :media="scope.row.Logo" />
        </template>
      </el-table-column>

      <el-table-column prop="SchId" label="机构ID" width="100" show-overflow-tooltip class-name="col-mono"></el-table-column>
      <el-table-column prop="SchType" label="机构类型" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ formatStatus(scope.row.SchType) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="SubDeptCount" label="子部门" width="80" align="center"></el-table-column>

      <el-table-column prop="IsSyncTb" label="天波对接" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.DeptOrgType === 'school'">
            <el-tag :type="scope.row.IsSyncTb === '1' ? 'success' : 'info'" size="mini" class="tbl-status-tag">
              {{ scope.row.IsSyncTb === '1' ? `已对接 · ${scope.row.TbThirdPartId || '-'}` : '未对接' }}
            </el-tag>
          </template>
          <template v-else>
            <el-tag :type="scope.row.TbThirdPartId > 0 ? 'success' : 'info'" size="mini" class="tbl-status-tag">
              {{ scope.row.TbThirdPartId > 0 ? `已绑定 · ${scope.row.TbThirdPartId}` : '未绑定' }}
            </el-tag>
          </template>
        </template>
      </el-table-column>

      <el-table-column label="已同步" width="72" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.IsSyncTb === '1' ? scope.row.SyncedSubDeptCount : '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ThirdPartId" label="第三方ID" min-width="170" show-overflow-tooltip class-name="col-mono"></el-table-column>

      <el-table-column prop="EnableOrderFood" label="订餐" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.EnableOrderFood ? 'success' : 'danger'" size="mini" disable-transitions>{{
            scope.row.EnableOrderFood ? "已开启" : "未开启"
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="ExpirationDate" label="到期日期" width="110" align="center">
        <template slot-scope="scope">
          <span :style="{ color: getDateColor(scope.row.ExpirationDate) }">{{ scope.row.ExpirationDate }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="168" align="center">
      </el-table-column>

      <el-table-column label="操作" width="120" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="openDeptConfig(scope.row)">
            部门配置
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <div class="pagination-container">
      <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :current-page="page" :page-size="PageSize" :total="total"></el-pagination>
    </div>

    <!--编辑界面：短字段两列排布，地址/天波说明/Logo 整行。最后修改：2026-09-23-->
    <el-dialog
      title="编辑"
      custom-class="dept-org-form-dialog"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      width="720px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm" class="dept-org-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构ID" prop="SchId">
              <el-input
                v-model="editForm.SchId"
                auto-complete="off"
                :disabled="!!editFormOriginalSchId"
                :placeholder="editFormOriginalSchId ? '机构ID创建后不可修改' : '请输入机构ID'"
              ></el-input>
              <div v-if="editFormOriginalSchId" class="dept-org-form-tip">
                机构ID创建后不可修改（已关联用户映射等数据）
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构名称" prop="Name">
              <el-input v-model="editForm.Name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构类型">
              <el-radio-group v-model="editForm.SchType" v-removeAriaHidden>
                <el-radio class="radio" label="WeiXin">微信</el-radio>
                <el-radio class="radio" label="DingDing">钉钉</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item v-if="editForm.DeptOrgType === 'school'" label="启用天波对接" prop="IsSyncTb">
          <el-switch v-model="editForm.IsSyncTb" active-value="1" inactive-value="0" active-text="对接"
            inactive-text="关闭"></el-switch>
          <div class="dept-org-form-tip">
            无天波门禁的学校请关闭。开启后可做「天波基础信息同步」，并允许开通开放平台应用。细项可在开放平台「学校天波配置」调整。
          </div>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="第三方ID" prop="ThirdPartId">
              <el-input v-model="editForm.ThirdPartId" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="负责人" prop="Leader">
              <el-input v-model="editForm.Leader" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="地址" prop="Address">
          <el-input v-model="editForm.Address" auto-complete="off"></el-input>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="到期时间" prop="ExpirationDate">
              <el-date-picker
                v-model="editForm.ExpirationDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="排列序号" prop="OrderSort">
              <el-input type="number" v-model.number="editForm.OrderSort" auto-complete="off" placeholder="数字越小越靠前"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Logo">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false"
            :show-file-list="false" :on-change="handleLogoChange">
            <img v-if="deferredImageDisplay('logo', imageUrl)" v-oss-src="deferredImageDisplay('logo', imageUrl)" class="avatar" />
            <i v-if="!deferredImageDisplay('logo', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面：短字段两列排布，地址/Logo 整行。最后修改：2026-09-23-->
    <el-dialog
      title="新增"
      custom-class="dept-org-form-dialog"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      width="720px"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm" class="dept-org-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构ID" prop="SchId">
              <el-input v-model="addForm.SchId" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构名称" prop="Name">
              <el-input v-model="addForm.Name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="机构类型">
              <el-radio-group v-model="addForm.SchType" v-removeAriaHidden>
                <el-radio class="radio" label="WeiXin">微信</el-radio>
                <el-radio class="radio" label="DingDing">钉钉</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item v-if="addForm.DeptOrgType === 'school'" label="启用天波对接" prop="IsSyncTb">
          <el-switch v-model="addForm.IsSyncTb" active-value="1" inactive-value="0" active-text="对接"
            inactive-text="关闭"></el-switch>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="第三方ID" prop="ThirdPartId">
              <el-input v-model="addForm.ThirdPartId" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="负责人" prop="Leader">
              <el-input v-model="addForm.Leader" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="地址" prop="Address">
          <el-input v-model="addForm.Address" auto-complete="off"></el-input>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="到期时间" prop="ExpirationDate">
              <el-date-picker
                v-model="addForm.ExpirationDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="排列序号" prop="OrderSort">
              <el-input type="number" v-model.number="addForm.OrderSort" auto-complete="off" placeholder="数字越小越靠前"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Logo">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false"
            :show-file-list="false" :on-change="handleLogoChange">
            <img v-if="deferredImageDisplay('logo', imageUrl)" v-oss-src="deferredImageDisplay('logo', imageUrl)" class="avatar" />
            <i v-if="!deferredImageDisplay('logo', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 部门配置对话框 -->
    <el-dialog :visible.sync="deptConfigDialogVisible" width="820px" top="5vh"
      :close-on-click-modal="false" :append-to-body="true" :lock-scroll="true"
      @open="onDeptConfigDialogOpen" @closed="onDeptConfigDialogClosed"
      custom-class="dept-config-dialog">

      <div slot="title" class="dept-config-titlebar">
        <div class="dept-config-titlebar-main">
          <span class="dept-config-titlebar-name">{{ deptConfigForm.Name }}</span>
          <span class="dept-config-titlebar-tag">部门配置</span>
        </div>
      </div>

      <div class="dept-config-shell">
        <nav class="dept-config-nav">
          <div
            v-for="item in deptConfigNavItems"
            :key="item.name"
            class="dept-config-nav-item"
            :class="{ 'is-active': deptConfigActiveTab === item.name }"
            @click="deptConfigActiveTab = item.name">
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </nav>

        <div class="dept-config-content">

          <!-- 基础设置 -->
          <div v-show="deptConfigActiveTab === 'base'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>基础设置</h4>
              <p>城市与常用功能</p>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label">基本信息</div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">所在城市</span>
                </div>
                <div class="cfg-item-control">
                  <el-cascader v-model="cityPath" :options="cityData" :props="cityProps" :show-all-levels="false"
                    placeholder="请选择城市" size="small" style="width:240px" @change="handleCityChange"></el-cascader>
                </div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">过期提示文案</span>
                  <span class="cfg-desc">学校服务到期后登录/检查接口返回的提示</span>
                </div>
                <div class="cfg-item-control">
                  <el-input
                    v-model="deptConfigForm.schoolExpiredContactAdminMsg"
                    size="small"
                    clearable
                    placeholder="学校服务已到期，请联系管理员。"
                    style="width:320px"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>

          <!-- 任务与通知 -->
          <div v-show="deptConfigActiveTab === 'task'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>任务与通知</h4>
              <p>消息推送与定时任务</p>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label">
                <div class="cfg-group-label-text">
                  <span>超时未返校通知推送</span>
                  <span class="cfg-group-sublabel">请假超时未返校时向家长推送</span>
                </div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">开启</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.TimeoutReturnSchoolNotice"></el-switch></div>
              </div>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label">
                <div class="cfg-group-label-text">
                  <span>校园考勤实时推送</span>
                  <span class="cfg-group-sublabel">按人员「用户类型」分别控制刷卡考勤消息；不影响请假、汇总等其他通知；两项均关闭则不推送</span>
                </div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">专用类型推送</span>
                  <span class="cfg-desc">用户类型为「专用」</span>
                </div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.EnablePushForSpecialType"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">普通类型推送</span>
                  <span class="cfg-desc">用户类型为「普通」</span>
                </div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.EnablePushForNormalType"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">教师考勤推送</span>
                  <span class="cfg-desc">钉钉推送给打卡教师本人；关闭后该校教师刷卡不再推送</span>
                </div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.TeacherKaoQinPushEnabled"></el-switch></div>
              </div>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label cfg-group-label--with-tip">
                <span>定时考勤汇总推送</span>
                <el-tooltip effect="dark" :content="deptConfigForm.DailyKaoqinSummaryPushTaskId || '暂无任务ID'" placement="top">
                  <i class="el-icon-info cfg-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">开启</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.EnableDailyKaoqinSummaryPush"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">推送时间</span></div>
                <div class="cfg-item-control">
                  <el-time-picker v-model="deptConfigForm.DailyKaoqinSummaryPushTime" format="HH:mm" value-format="HH:mm"
                    :disabled="!deptConfigForm.EnableDailyKaoqinSummaryPush" :clearable="false"
                    size="small" style="width:120px"></el-time-picker>
                </div>
              </div>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label cfg-group-label--with-tip">
                <span class="cfg-group-title-row">
                  <span>自动获取新闻</span>
                  <span class="cfg-source-tag">央视新闻</span>
                </span>
                <el-tooltip effect="dark" :content="deptConfigForm.AutoNewsFetchTaskId || '暂无任务ID'" placement="top">
                  <i class="el-icon-info cfg-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">开启</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.EnableAutoNewsFetch"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">获取时间</span></div>
                <div class="cfg-item-control">
                  <el-time-picker v-model="deptConfigForm.AutoNewsFetchTime" format="HH:mm" value-format="HH:mm"
                    :disabled="!deptConfigForm.EnableAutoNewsFetch" :clearable="false"
                    size="small" style="width:120px"></el-time-picker>
                </div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">新闻会签</span>
                  <span class="cfg-desc">开启后需全部审批人同意才发布；关闭则任一审批人同意即可</span>
                </div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.TempNewsAuditRequireAll"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">默认有效期</span>
                  <span class="cfg-desc">审核通过后自动写入新闻结束时间。0 表示永久；大于 0 为含当天的天数</span>
                </div>
                <div class="cfg-item-control">
                  <el-input-number v-model="deptConfigForm.TempNewsDefaultValidDays" :min="0" :max="3650" :step="1"
                    size="small" controls-position="right" style="width:120px"></el-input-number>
                  <span class="cfg-desc" style="margin-left:8px;">天</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 移动端 -->
          <div v-show="deptConfigActiveTab === 'app'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>移动端</h4>
              <p>家长端与教师端权限控制</p>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label">家长端</div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">显示请假返校时间</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.ShowLeaveReturnSchoolTime"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">允许修改卡号</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.CardControl"></el-switch></div>
              </div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">允许修改头像</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.AvatarControl"></el-switch></div>
              </div>
            </div>
            <div class="cfg-group">
              <div class="cfg-group-label">教师端</div>
              <div class="cfg-item">
                <div class="cfg-item-text"><span class="cfg-label">允许修改人员类型</span></div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.MobileAllowEditUserType"></el-switch></div>
              </div>
            </div>
          </div>

          <!-- 微信推送（上下分区，避免左右挤窄导致描述竖排）。最后更新：2026-07-25 -->
          <div v-show="deptConfigActiveTab === 'parentWechat'" class="cfg-page cfg-page--wx">
            <div class="cfg-page-head">
              <h4>微信推送</h4>
              <p v-if="deptConfigForm.SchType === 'DingDing'">钉钉学校可开启双通道：钉钉 + 公众号推送家长</p>
              <p v-else>微信学校：家长端登录与模板推送（AppId 取机构第三方 ID）</p>
            </div>

            <!-- 1. 通道 -->
            <div class="cfg-group">
              <div class="cfg-group-label">通道设置</div>
              <template v-if="isDingDingSchoolForWechatPush">
                <div class="cfg-item">
                  <div class="cfg-item-text">
                    <span class="cfg-label">开启微信登录推送</span>
                    <span class="cfg-desc">开启后本场景优先走公众号；是否钉钉兜底见下方开关</span>
                  </div>
                  <div class="cfg-item-control">
                    <el-switch v-model="deptConfigForm.parentPushWeChatEnabled"></el-switch>
                  </div>
                </div>
                <div class="cfg-item">
                  <div class="cfg-item-text">
                    <span class="cfg-label">微信不可用时钉钉兜底</span>
                    <span class="cfg-desc">默认关闭：只推微信。开启后，缺模板或家长未绑定微信时仍推钉钉</span>
                  </div>
                  <div class="cfg-item-control">
                    <el-switch
                      v-model="deptConfigForm.parentPushWeChatDingTalkFallback"
                      :disabled="!deptConfigForm.parentPushWeChatEnabled"
                    ></el-switch>
                  </div>
                </div>
                <div class="cfg-item cfg-item--stack">
                  <div class="cfg-item-text">
                    <span class="cfg-label">公众号 AppId</span>
                    <span class="cfg-desc">与系统 WeChatConfig 中的 appid 一致，登录与推送共用</span>
                  </div>
                  <el-input
                    v-model="deptConfigForm.parentPushWeChatAppId"
                    clearable
                    size="small"
                    :disabled="!deptConfigForm.parentPushWeChatEnabled"
                    placeholder="例如 wx0123456789abcdef"
                    class="cfg-wx-appid-input"
                  />
                </div>
              </template>
              <div v-else class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">公众号 AppId</span>
                  <span class="cfg-desc">使用机构「第三方 ID」，无需在此重复填写</span>
                </div>
                <div class="cfg-item-control">
                  <code class="cfg-wx-appid-chip">{{ parentWxResolvedAppIdDisplay }}</code>
                </div>
              </div>
            </div>

            <!-- 2. 推送场景（仅钉钉校勾选；微信校默认全开） -->
            <div v-if="isDingDingSchoolForWechatPush" class="cfg-group">
              <div class="cfg-group-label">推送场景</div>
              <div class="cfg-item cfg-item--stack cfg-wx-scenes">
                <p class="cfg-wx-hint">
                  仅已绑定本校公众号的监护人会收到；
                  <span class="cfg-wx-hint-danger">未配模板的场景发送时自动跳过。</span>
                </p>
                <div class="cfg-wx-scene-grid">
                  <button
                    v-for="opt in parentWxSceneOptions"
                    :key="opt.value"
                    type="button"
                    class="cfg-wx-scene-card"
                    :class="{
                      'is-disabled': !deptConfigForm.parentPushWeChatEnabled,
                      'is-checked': isParentWxSceneChecked(opt.value),
                      'is-miss': parentWxSceneMissMap[opt.value]
                    }"
                    :disabled="!deptConfigForm.parentPushWeChatEnabled"
                    @click="toggleParentWxScene(opt.value)"
                  >
                    <span class="cfg-wx-scene-check" aria-hidden="true">
                      <i v-if="isParentWxSceneChecked(opt.value)" class="el-icon-check"></i>
                    </span>
                    <span class="cfg-wx-scene-label">{{ opt.label }}</span>
                    <span v-if="parentWxSceneMissMap[opt.value]" class="cfg-wx-scene-badge">缺模板</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- 3. 模板就绪（钉钉校 / 微信校统一） -->
            <div class="cfg-group">
              <div class="cfg-group-label cfg-group-label--between">
                <span>模板就绪</span>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-refresh"
                  :disabled="parentWxTemplateStatusLoading"
                  @click="loadParentWeChatTemplateStatus"
                >刷新</el-button>
              </div>
              <div v-loading="parentWxTemplateStatusLoading" class="cfg-wx-ready">
                <div v-if="!parentWxTemplateStatus.hasAppId" class="cfg-wx-ready-banner is-warn">
                  <i class="el-icon-warning-outline"></i>
                  <span>尚未解析到 AppId，无法核对模板。钉钉校请填写上方 AppId；微信校请确认机构第三方 ID。</span>
                </div>
                <div v-else class="cfg-wx-ready-banner" :class="parentWxTemplateStatus.missingCount ? 'is-warn' : 'is-ok'">
                  <i :class="parentWxTemplateStatus.missingCount ? 'el-icon-warning-outline' : 'el-icon-circle-check'"></i>
                  <span>
                    <template v-if="parentWxTemplateStatus.missingCount">
                      缺 {{ parentWxTemplateStatus.missingCount }} 项 · 已就绪 {{ parentWxReadyCount }} 项
                    </template>
                    <template v-else>标准家长模板均已就绪（{{ parentWxReadyCount }} 项）</template>
                    <em v-if="parentWxTemplateStatus.appId"> · {{ parentWxTemplateStatus.appId }}</em>
                  </span>
                </div>

                <div v-if="parentWxMissingItems.length" class="cfg-wx-ready-block">
                  <div class="cfg-wx-ready-caption">未配置</div>
                  <div class="cfg-wx-tag-wrap">
                    <el-tooltip
                      v-for="item in parentWxMissingItems"
                      :key="'m-' + item.businessKey + ':' + item.sceneKey"
                      :content="item.businessKey + ' / ' + item.sceneKey + ' · ' + item.statusText"
                      placement="top"
                    >
                      <span class="cfg-wx-tag is-miss">{{ item.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="parentWxReadyItems.length" class="cfg-wx-ready-block">
                  <div class="cfg-wx-ready-caption">
                    已配置
                    <button type="button" class="cfg-wx-toggle" @click="parentWxShowReadyTags = !parentWxShowReadyTags">
                      {{ parentWxShowReadyTags ? '收起' : '展开' }}
                    </button>
                  </div>
                  <div v-show="parentWxShowReadyTags" class="cfg-wx-tag-wrap">
                    <el-tooltip
                      v-for="item in parentWxReadyItems"
                      :key="'ok-' + item.businessKey + ':' + item.sceneKey"
                      :content="item.businessKey + ' / ' + item.sceneKey"
                      placement="top"
                    >
                      <span class="cfg-wx-tag is-ok">{{ item.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <!-- 4. 绑定 -->
            <div class="cfg-group">
              <div class="cfg-group-label">绑定设置</div>
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">绑定需短信认证</span>
                  <span class="cfg-desc">关闭后改为核对第一位监护人手机中间 5 位（先选学生）或完整登记号（先输手机）</span>
                </div>
                <div class="cfg-item-control">
                  <el-switch
                    v-model="deptConfigForm.parentPushWeChatRequireSmsVerification"
                    :disabled="isDingDingSchoolForWechatPush && !deptConfigForm.parentPushWeChatEnabled"
                  ></el-switch>
                </div>
              </div>
              <div class="cfg-item cfg-item--stack">
                <div class="cfg-item-text">
                  <span class="cfg-label">绑定入口模式</span>
                  <span class="cfg-desc">独立绑定页默认先选学生；也可改为先输手机号搜学生</span>
                </div>
                <el-radio-group
                  v-model="deptConfigForm.parentWxBindEntryMode"
                  :disabled="isDingDingSchoolForWechatPush && !deptConfigForm.parentPushWeChatEnabled"
                  class="cfg-radio-row"
                >
                  <el-radio label="StudentFirst">先选学生再绑</el-radio>
                  <el-radio label="PhoneFirst">先输手机号找学生</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>

          <!-- 人脸比对 -->
          <div v-show="deptConfigActiveTab === 'faceCompare'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>人脸比对</h4>
              <p>德育「拍照找人」等人脸比对能力</p>
            </div>
            <div class="cfg-group">
              <div class="cfg-item">
                <div class="cfg-item-text">
                  <span class="cfg-label">启用人脸比对</span>
                  <span class="cfg-desc">阿里云密钥在「阿里云」中配置</span>
                </div>
                <div class="cfg-item-control"><el-switch v-model="deptConfigForm.enableFaceCompare"></el-switch></div>
              </div>
            </div>
          </div>

          <!-- 阿里云 -->
          <div v-show="deptConfigActiveTab === 'aliyun'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>阿里云</h4>
            </div>

            <div class="cfg-group">
              <div class="cfg-group-label cfg-group-label--ak">
                <div class="cfg-group-label-text">
                  <span>AccessKey</span>
                  <span class="cfg-group-sublabel">勾选并填齐下方凭证走本校 AK，未勾选走平台 AK</span>
                </div>
                <div class="aliyun-service-tags">
                  <div class="aliyun-service-item">
                    <el-checkbox v-model="deptConfigForm.useSchoolAliyunForFaceSearch" size="mini" border>人脸</el-checkbox>
                    <span :class="['aliyun-ak-tag', faceAkStatus.cls]">{{ faceAkStatus.label }}</span>
                  </div>
                  <div class="aliyun-service-item">
                    <el-checkbox v-model="deptConfigForm.useSchoolAliyunForLicensePlateOcr" size="mini" border>车牌</el-checkbox>
                    <span :class="['aliyun-ak-tag', plateAkStatus.cls]">{{ plateAkStatus.label }}</span>
                  </div>
                </div>
              </div>
              <div class="cfg-form-grid cfg-form-grid--single">
                <div class="cfg-form-field">
                  <label>AccessKey ID</label>
                  <el-input v-model="deptConfigForm.schoolAliyunAccessKeyId" size="small" clearable placeholder="LTAI…"
                    autocomplete="off" autocorrect="off" spellcheck="false"
                    :class="{ 'aliyun-ak-password-input': !showSchoolAliyunAccessKeyId }" class="aliyun-ak-input">
                    <i slot="suffix" :class="showSchoolAliyunAccessKeyId ? 'el-icon-view' : 'el-icon-minus'"
                      class="cfg-eye-icon" @click="showSchoolAliyunAccessKeyId = !showSchoolAliyunAccessKeyId"></i>
                  </el-input>
                </div>
                <div class="cfg-form-field">
                  <label>AccessKey Secret</label>
                  <el-input v-model="deptConfigForm.schoolAliyunAccessKeySecret" size="small" clearable
                    autocomplete="new-password" autocorrect="off" spellcheck="false"
                    :class="{ 'aliyun-ak-password-input': !showSchoolAliyunAccessKeySecret }" class="aliyun-ak-input"
                    :placeholder="schoolAliyunSecretPlaceholder">
                    <i slot="suffix" :class="showSchoolAliyunAccessKeySecret ? 'el-icon-view' : 'el-icon-minus'"
                      class="cfg-eye-icon" @click="showSchoolAliyunAccessKeySecret = !showSchoolAliyunAccessKeySecret"></i>
                  </el-input>
                </div>
                <div class="cfg-form-field">
                  <label>FaceBody 域名 <em>可选</em></label>
                  <el-input v-model="deptConfigForm.schoolAliyunFaceBodyEndpoint" size="small" clearable
                    placeholder="facebody.cn-shanghai.aliyuncs.com"></el-input>
                </div>
                <div class="cfg-form-field">
                  <label>车牌 OCR 域名 <em>固定</em></label>
                  <el-input :value="defaultOcrApiEndpoint" size="small" disabled></el-input>
                  <p class="cfg-form-field-hint">文字识别官方仅杭州接入点，无需填写。</p>
                </div>
              </div>
              <p v-if="schoolAkFacePlateWarn" class="cfg-field-hint cfg-field-hint--warn">{{ schoolAkFacePlateWarn }}</p>
            </div>

            <div class="cfg-group">
              <div class="cfg-group-label cfg-group-label--between">
                <div>
                  <span>OSS 存储</span>
                  <span class="cfg-group-sublabel">{{ ossStorageHint }}</span>
                </div>
                <div class="aliyun-oss-toolbar">
                  <el-switch v-model="deptConfigForm.schoolOssEnabled" active-color="#2563eb"></el-switch>
                  <span class="aliyun-toolbar-label">总开关</span>
                  <span class="aliyun-toolbar-divider"></span>
                  <el-checkbox
                    v-model="deptConfigForm.useSchoolAliyunForOss"
                    :disabled="!deptConfigForm.schoolOssEnabled"
                    size="mini">
                    本校 AK
                  </el-checkbox>
                  <span
                    v-if="deptConfigForm.schoolOssEnabled"
                    :class="['aliyun-ak-tag', ossUploadUsesSchoolAk ? 'is-school' : 'is-platform']">
                    {{ ossUploadAkLabel }}
                  </span>
                </div>
              </div>
              <div class="cfg-form-grid cfg-form-grid--single">
                <div class="cfg-form-field">
                  <label>默认 Bucket 域名</label>
                  <el-input v-model="deptConfigForm.schoolAliyunOssEndpoint" size="small" clearable
                    placeholder="lhxxoss.oss-cn-shanghai.aliyuncs.com"></el-input>
                </div>
                <div class="cfg-form-field">
                  <label>对象前缀</label>
                  <el-input v-model="deptConfigForm.schoolAliyunOssObjectPrefix" size="small" clearable
                    placeholder="如 lhxx"></el-input>
                </div>
              </div>

              <template v-if="deptConfigForm.schoolOssEnabled">
                <div class="cfg-subsection">
                  <div class="cfg-subsection-title">STS 直传</div>
                  <p class="cfg-subsection-desc">浏览器直传；总开关关闭时走本机存储</p>
                  <div class="cfg-form-grid cfg-form-grid--single cfg-form-grid--flush">
                    <div class="cfg-form-field">
                      <el-checkbox v-model="deptConfigForm.useSchoolAliyunForOssVideo"
                        @change="onOssVideoSwitchChange">视频直传</el-checkbox>
                    </div>
                    <div v-if="deptConfigForm.useSchoolAliyunForOssVideo" class="cfg-form-field">
                      <label>视频 Bucket 域名</label>
                      <el-input v-model="deptConfigForm.schoolAliyunOssEndpointVideo" size="small" clearable
                        :placeholder="resolveVideoBucketPlaceholder()">
                      </el-input>
                    </div>
                    <div class="cfg-form-field">
                      <label>STS RoleArn</label>
                      <el-input v-model="deptConfigForm.schoolAliyunStsRoleArn" size="small" clearable
                        placeholder="acs:ram::账号ID:role/角色名"></el-input>
                    </div>
                  </div>
                </div>
                <div class="cfg-subsection">
                  <div class="cfg-subsection-title">服务端转存</div>
                  <p class="cfg-subsection-desc">手机端、API、头像迁移等经服务端上传至 OSS。摄像头视频由媒体服务直传，对象路径不在此配置</p>
                  <div class="aliyun-type-grid">
                    <div
                      v-for="typeItem in ossTypeItems"
                      :key="typeItem.switchKey"
                      :class="['aliyun-type-chip', deptConfigForm[typeItem.switchKey] ? 'is-active' : '']">
                      <el-checkbox
                        v-model="deptConfigForm[typeItem.switchKey]"
                        @change="val => onOssTypeSwitchChange(typeItem, val)">
                        {{ typeItem.label }}
                      </el-checkbox>
                      <el-input
                        v-if="deptConfigForm[typeItem.switchKey]"
                        v-model="deptConfigForm[typeItem.endpointKey]"
                        clearable size="mini" class="aliyun-type-bucket-input"
                        :placeholder="resolveTypeDefaultEndpoint(typeItem) || '专用 Bucket（不填用平台/学校默认）'">
                      </el-input>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- 人员类型 -->
          <div v-show="deptConfigActiveTab === 'liveType'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>人员类型</h4>
              <p>只改本校三种类型的展示名称，业务筛选仍按固定 ID</p>
            </div>
            <el-alert
              v-if="liveTypeIsDefault"
              title="当前为系统默认名称，保存后作为本校配置。"
              type="info"
              :closable="false"
              show-icon
              style="margin-bottom:16px"
            />
            <div class="cfg-group" v-loading="liveTypeLoading">
              <div class="cfg-group-label">类型名称</div>
              <div v-for="item in liveTypeItems" :key="item.LiveTypeId" class="cfg-item cfg-item--live-type">
                <div class="cfg-item-text cfg-live-type-meta">
                  <span class="cfg-label">{{ item.LiveTypeId }}</span>
                  <span class="cfg-live-type-default">默认：{{ item.DefaultLiveTypeName || '-' }}</span>
                </div>
                <div class="cfg-item-control">
                  <el-input
                    v-model="item.LiveTypeName"
                    maxlength="20"
                    show-word-limit
                    placeholder="请输入展示名称"
                    size="small"
                    style="width:240px"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-show="deptConfigActiveTab === 'pay'" class="cfg-page">
            <div class="cfg-page-head">
              <h4>支付配置</h4>
              <p class="cfg-group-sublabel">话机套餐等业务收款通道；启用后家长端按此展示</p>
            </div>

            <div class="cfg-group">
              <div class="cfg-group-label">启用支付方式</div>
              <div class="cfg-pay-channel-grid">
                <button
                  v-for="opt in payChannelOptions"
                  :key="opt.value"
                  type="button"
                  class="cfg-pay-channel-card"
                  :class="{ 'is-checked': isPayChannelEnabled(opt.value) }"
                  @click="togglePayChannel(opt.value)"
                >
                  <span class="cfg-pay-channel-check" aria-hidden="true">
                    <i v-if="isPayChannelEnabled(opt.value)" class="el-icon-check"></i>
                  </span>
                  <span class="cfg-pay-channel-body">
                    <span class="cfg-pay-channel-title">{{ opt.label }}</span>
                    <span class="cfg-pay-channel-desc">{{ opt.desc }}</span>
                  </span>
                </button>
              </div>
            </div>

            <div class="cfg-group">
              <div class="cfg-group-label">商户绑定</div>
              <div class="cfg-form-grid cfg-form-grid--single">
                <div class="cfg-form-field">
                  <label>支付宝应用 <em>启用支付宝时必选</em></label>
                  <el-select v-model="payConfigForm.aliPayAppId" filterable clearable placeholder="选择支付宝应用" style="width:100%"
                    :disabled="!isPayChannelEnabled(2)">
                    <el-option v-for="item in aliPayOptions" :key="item.AppId || item.appId"
                      :label="(item.Name || item.name || '') + ' (' + (item.AppId || item.appId) + ')'"
                      :value="item.AppId || item.appId" />
                  </el-select>
                </div>
                <div class="cfg-form-field">
                  <label>微信支付商户 <em>启用微信时必选</em></label>
                  <el-select v-model="payConfigForm.wxPayConfigId" filterable clearable placeholder="选择微信商户配置" style="width:100%"
                    :disabled="!isPayChannelEnabled(1)">
                    <el-option v-for="item in wxPayOptions" :key="item.Id || item.id"
                      :label="(item.Name || item.name || '') + ' / ' + (item.MchId || item.mchId || '')"
                      :value="item.Id || item.id" />
                  </el-select>
                </div>
                <div v-if="isPayChannelEnabled(3)" class="cfg-pay-jl-note">
                  <i class="el-icon-info"></i>
                  <div>
                    <strong>嘉联通道</strong>由第三方嘉联支付承接，实际收款商户为
                    <em>豆信智慧校园服务</em>，使用系统全局嘉联配置，无需在此单独选择商户。
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div slot="footer" class="dept-config-footer">
        <el-button @click="deptConfigDialogVisible = false">取消</el-button>
        <el-button v-if="deptConfigActiveTab === 'liveType'" type="primary" :loading="liveTypeSaving" @click="saveLiveTypeConfig">保存人员类型</el-button>
        <el-button v-else type="primary" :loading="deptConfigLoading" @click="saveDeptConfig">保存配置</el-button>
      </div>
    </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getSchTreeTable, exportSchoolTreeTable, removeDepartment, editDepartment, addDepartment, setOrderFood, getOssPlatformDefaults, getParentWeChatTemplateStatus, getSchoolPayConfig, saveSchoolPayConfig, getSchoolAliPayOptions, getSchoolWxPayOptions, getStudentLiveTypeBySchId, saveStudentLiveType } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import city from './city'
import { getUnifiedPageSize } from '../../utils/elPaginationUnify';

export default {
  components: { Toolbar },
  data() {
    return {
      BaseApiUrl: BaseApiUrl, //网络前缀
      /** 新版文字识别 OCR 固定域名（与 AliyunCommon 上海区域一致） */
      defaultOcrApiEndpoint: 'ocr-api.cn-hangzhou.aliyuncs.com',
      buttonList: [],
      searchList: [
        {
          label: '名称',
          key: 'name',
          width: '140px',
        },
        {
          label: '机构ID',
          key: 'schId',
          width: '140px',
        },
        {
          label: '机构类型',
          key: 'schType',
          type: 'select',
          clearable: true,
          width: '120px',
          options: [
            { label: '全部', value: '' },
            { label: '微信', value: 'WeiXin' },
            { label: '钉钉', value: 'DingDing' },
          ],
        },
        {
          label: '是否开启订餐',
          key: 'enableOrderFood',
          type: 'select',
          clearable: true,
          width: '130px',
          options: [
            { label: '全部', value: '' },
            { label: '已开启', value: '1' },
            { label: '未开启', value: '0' },
          ],
        },
        {
          label: '是否过期',
          key: 'expired',
          type: 'select',
          clearable: true,
          width: '120px',
          options: [
            { label: '全部', value: '' },
            { label: '已过期', value: '1' },
            { label: '未过期', value: '0' },
          ],
        },
      ],
      currentRow: null,
      options: [],
      filters: {
        name: '',
        schId: '',
        schType: '',
        enableOrderFood: '',
        expired: '',
      },
      users: [],
      modules: [], //接口api列表
      statusList: [
        { Name: "激活", value: true },
        { Name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      PageSize: getUnifiedPageSize(),
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      /** 打开编辑时的原机构ID；有值则禁止修改 SchId */
      editFormOriginalSchId: "",
      editFormRules: {
        Name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        SchId: [{ required: true, message: "请输入机构ID", trigger: "blur" }],
        //PidArr: [{ required: true, message: "请选择父节点", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        OrderSort: 0,
        PidArr: [],
        CreateBy: "",
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: false,
        SchId: "",
        SchType: "",
        ThirdPartId: "",
        Address: "",
        IsCompany: false,
        ExpirationDate: '',
        DeptOrgType: "school",
        IsSyncTb: '0', //是否同步天波
        TbThirdPartId: '', // 天波第三方ID
        Logo: ''
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        SchId: [{ required: true, message: "请输入机构ID", trigger: "blur" }],
        //PidArr: [{ required: true, message: "请选择父节点", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        OrderSort: 0,
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: true,
        SchId: "",
        SchType: "",
        ThirdPartId: "",
        Address: "",
        IsCompany: false,
        ExpirationDate: '',
        DeptOrgType: "school",
        IsSyncTb: '0', //是否同步天波
        TbThirdPartId: '', // 天波第三方ID
        Logo: ''
      },
      isResouceShow: 0,
      imageUrl: '',
      imageLoadding: false,

      //部门配置
      deptConfigDialogVisible: false,
      deptConfigActiveTab: 'base', // 部门配置当前选中标签页
      deptConfigForm: {
        Id: null,
        Name: '',
        SchId: '',
        City: '', // 所在城市，存储城市code
        CardControl: true,
        AvatarControl: true,
        MobileAllowEditUserType: 1,
        EnableOrderFood: 1,
        TimeoutReturnSchoolNotice: 1,
        EnableDailyKaoqinSummaryPush: false, // 定时推送考勤统汇总开关（默认关闭）
        DailyKaoqinSummaryPushTime: '09:00', // 定时推送考勤统汇总时间（默认09:00）
        ShowLeaveReturnSchoolTime: false, // 新增：请假返校时间是否显示
        // 自动获取新闻相关设置
        EnableAutoNewsFetch: false, // 是否自动获取新闻 0-关闭 1-开启（默认关闭）
        AutoNewsFetchTime: '07:00', // 自动获取新闻时间（默认09:00）
        AutoNewsFetchTaskId: '', // 自动获取新闻任务ID
        TempNewsAuditRequireAll: false, // 新闻审核会签：全部同意
        TempNewsDefaultValidDays: 0, // 审核通过后默认有效天数，0 永久
        // 推送设置
        EnablePushForSpecialType: true,
        EnablePushForNormalType: true,
        TeacherKaoQinPushEnabled: true,
        SchType: '',
        parentPushWeChatEnabled: false,
        parentPushWeChatDingTalkFallback: false,
        parentPushWeChatAppId: '',
        parentPushWeChatSceneList: [],
        parentPushWeChatRequireSmsVerification: true,
        OrganizationChart: '',
        useSchoolAliyunForFaceSearch: false,
        useSchoolAliyunForLicensePlateOcr: false,
        useSchoolAliyunForOss: false,
        schoolOssEnabled: false,
        useSchoolAliyunForOssImage: false,
        useSchoolAliyunForOssAvatar: false,
        useSchoolAliyunForOssAudio: false,
        useSchoolAliyunForOssDocument: false,
        useSchoolAliyunForOssAttendance: false,
        useSchoolAliyunForOssCameraVideo: false,
        useSchoolAliyunForOssLog: false,
        schoolAliyunOssEndpointImage: '',
        schoolAliyunOssEndpointAvatar: '',
        schoolAliyunOssEndpointAudio: '',
        schoolAliyunOssEndpointDocument: '',
        schoolAliyunOssEndpointAttendance: '',
        schoolAliyunOssEndpointCameraVideo: '',
        schoolAliyunOssEndpointLog: '',
        schoolAliyunOssEndpointVideo: '',
        schoolAliyunAccessKeyId: '',
        schoolAliyunAccessKeySecret: '',
        /** 仅用于占位提示；Secret 明文仍不从接口返回 */
        schoolAliyunAccessKeySecretPresent: false,
        schoolAliyunFaceBodyEndpoint: '',
        schoolAliyunOcrEndpoint: '',
        schoolAliyunOssEndpoint: '',
        schoolAliyunOssObjectPrefix: '',
        useSchoolAliyunForOssVideo: false,
        schoolAliyunStsRoleArn: '',
        /** 是否启用人脸比对（SchoolConfig EnableFaceCompare，默认不启用） */
        enableFaceCompare: false
      },
      payConfigForm: {
        aliPayAppId: '',
        wxPayConfigId: null,
        enabledPayTypes: []
      },
      /** 支付配置是否已从接口加载完成（未加载时禁止用空默认值覆盖库内配置）。创建于 2026-09-12 */
      payConfigLoaded: false,
      /** 当前弹窗的支付配置加载 Promise，保存前需等待。创建于 2026-09-12 */
      payConfigLoadPromise: null,
      /** 支付通道选项（展示用）。创建于 2026-08-07 */
      payChannelOptions: [
        { value: 1, label: '微信', desc: '公众号/小程序 JSAPI' },
        { value: 2, label: '支付宝', desc: '手机网站支付' },
        { value: 3, label: '嘉联', desc: '第三方通道 · 商户：豆信智慧校园服务' }
      ],
      aliPayOptions: [],
      wxPayOptions: [],
      deptConfigLoading: false,
      liveTypeItems: [],
      liveTypeIsDefault: false,
      liveTypeLoading: false,
      liveTypeSaving: false,
      /** 家长微信模板配置状态（钉钉校/微信校共用）。创建于 2026-07-25 */
      parentWxTemplateStatusLoading: false,
      parentWxTemplateStatus: {
        appId: '',
        hasAppId: false,
        missingCount: 0,
        items: []
      },
      parentWxTemplateStatusTimer: null,
      /** 模板状态请求序号，防止旧请求晚返回覆盖最新 AppId 的结果。创建于 2026-07-25 */
      parentWxTemplateStatusRequestSeq: 0,
      /** 已配置模板标签默认展开。创建于 2026-07-25 */
      parentWxShowReadyTags: true,
      /** 钉钉校推送场景选项。创建于 2026-07-25 */
      parentWxSceneOptions: [
        { label: '考勤', value: 'KaoQin' },
        { label: '请假', value: 'QingJia' },
        { label: '德育点评', value: 'DeYuStudentEval' },
        { label: '班级圈', value: 'ClassCircle' },
        { label: '协约币', value: 'AgreementCoinGrant' },
        { label: '消费余额', value: 'Consumer' },
        { label: '放学/滞留', value: 'Dismissal' },
        { label: '班级点到', value: 'ClassRollCall' },
        { label: '宿舍考勤', value: 'HostelKaoQin' },
        { label: '校车', value: 'SchoolBus' }
      ],
      ossTypeItems: [
        { label: '图片', switchKey: 'useSchoolAliyunForOssImage', endpointKey: 'schoolAliyunOssEndpointImage', configKey: 'Image' },
        { label: '头像', switchKey: 'useSchoolAliyunForOssAvatar', endpointKey: 'schoolAliyunOssEndpointAvatar', configKey: 'Avatar' },
        { label: '音频', switchKey: 'useSchoolAliyunForOssAudio', endpointKey: 'schoolAliyunOssEndpointAudio', configKey: 'Audio' },
        { label: '附件', switchKey: 'useSchoolAliyunForOssDocument', endpointKey: 'schoolAliyunOssEndpointDocument', configKey: 'Document' },
        { label: '考勤抓拍', switchKey: 'useSchoolAliyunForOssAttendance', endpointKey: 'schoolAliyunOssEndpointAttendance', configKey: 'Attendance' },
        { label: '摄像头视频', switchKey: 'useSchoolAliyunForOssCameraVideo', endpointKey: 'schoolAliyunOssEndpointCameraVideo', configKey: 'CameraVideo' },
        { label: '日志', switchKey: 'useSchoolAliyunForOssLog', endpointKey: 'schoolAliyunOssEndpointLog', configKey: 'Log' },
      ],
      /** 平台 appsettings 中的 OSS 默认 Bucket，用于勾选类型时自动填充 */
      ossPlatformDefaults: {
        DefaultEndpoint: '',
        DefaultRegion: 'oss-cn-shanghai',
        TypeEndpoints: {}
      },
      /** false=圆点隐藏；true=眼睛点开明文（不用 type=password，避免浏览器干预） */
      showSchoolAliyunAccessKeyId: false,
      showSchoolAliyunAccessKeySecret: false,
      cityData: city,
      cityPath: [], // 城市选择路径
      cityProps: {
        value: 'code',
        label: 'name',
        children: 'cities',
        checkStrictly: true
      },
    };
  },
  computed: {
    uploadHeaders() {
      let token = window.localStorage.Token || (this.$store && this.$store.state.token) || '';
      return {
        Authorization: 'Bearer ' + token
      };
    },
    /** 已有明文内容时不占位；仅空且曾保存过时提示留空不改 */
    schoolAliyunSecretPlaceholder() {
      const v = (this.deptConfigForm.schoolAliyunAccessKeySecret || '').trim();
      if (v.length > 0) return '';
      return this.deptConfigForm.schoolAliyunAccessKeySecretPresent
        ? '服务端已保存，留空不改；在此输入则覆盖'
        : '填写 AccessKey Secret';
    },
    /** 人脸当前实际走哪套 AK：未勾选=平台；勾选且填齐=本校；勾选未填齐=不可用 */
    faceAkStatus() {
      return this.resolveFacePlateAkStatus(this.deptConfigForm.useSchoolAliyunForFaceSearch);
    },
    /** 车牌当前实际走哪套 AK */
    plateAkStatus() {
      return this.resolveFacePlateAkStatus(this.deptConfigForm.useSchoolAliyunForLicensePlateOcr);
    },
    /** 人脸 / 车牌勾选但未配齐 AK 时的合并提示 */
    schoolAkFacePlateWarn() {
      if (this.isSchoolAkPairComplete) return '';
      const items = [];
      if (this.deptConfigForm.useSchoolAliyunForFaceSearch) items.push('人脸');
      if (this.deptConfigForm.useSchoolAliyunForLicensePlateOcr) items.push('车牌');
      if (items.length === 0) return '';
      return `已勾选${items.join('、')}但未填齐 AccessKey，对应功能将不可用（不会回退平台 AK）。`;
    },
    /** OSS 区块副标题 */
    ossStorageHint() {
      if (!this.deptConfigForm.schoolOssEnabled) return '关闭时文件存本机，Bucket 配置暂不生效';
      return '可按类型单独配置 Bucket';
    },
    /** OSS 实际上传使用的 AK 标签 */
    ossUploadUsesSchoolAk() {
      return this.deptConfigForm.schoolOssEnabled
        && this.deptConfigForm.useSchoolAliyunForOss
        && this.isSchoolOssOverrideReady;
    },
    ossUploadAkLabel() {
      if (!this.deptConfigForm.schoolOssEnabled) return '';
      if (this.ossUploadUsesSchoolAk) return '本校 AK';
      if (this.deptConfigForm.useSchoolAliyunForOss && !this.isSchoolOssOverrideReady) return '平台 AK';
      return '平台 AK';
    },
    /** AccessKey ID + Secret 是否已配齐（含服务端已保存 Secret） */
    isSchoolAkPairComplete() {
      const id = (this.deptConfigForm.schoolAliyunAccessKeyId || '').trim();
      const hasSecret = this.deptConfigForm.schoolAliyunAccessKeySecretPresent
        || (this.deptConfigForm.schoolAliyunAccessKeySecret || '').trim();
      return id.length > 0 && !!hasSecret;
    },
    /** 勾选 OSS用本校AK 且 AK + 默认 Bucket 齐全（对应后端 TryResolveOssOverride） */
    isSchoolOssOverrideReady() {
      return this.deptConfigForm.useSchoolAliyunForOss
        && this.isSchoolAkPairComplete
        && (this.deptConfigForm.schoolAliyunOssEndpoint || '').trim().length > 0;
    },
    /** 钉钉校才需要单独配公众号 AppId / 推送场景。最后更新：2026-07-23 */
    isDingDingSchoolForWechatPush() {
      return this.deptConfigForm.SchType === 'DingDing';
    },
    /** 微信校展示用的 AppId（接口解析结果或占位）。创建于 2026-07-25 */
    parentWxResolvedAppIdDisplay() {
      const id = (this.parentWxTemplateStatus && this.parentWxTemplateStatus.appId) || '';
      return id || '（未解析到第三方 ID）';
    },
    /** 未就绪模板列表。创建于 2026-07-25 */
    parentWxMissingItems() {
      return (this.parentWxTemplateStatus.items || []).filter((x) => !x.configured);
    },
    /** 已就绪模板列表。创建于 2026-07-25 */
    parentWxReadyItems() {
      return (this.parentWxTemplateStatus.items || []).filter((x) => x.configured);
    },
    parentWxReadyCount() {
      return this.parentWxReadyItems.length;
    },
    /**
     * 各推送场景是否仍有缺模板（用于场景卡片角标）。创建于 2026-07-25
     */
    parentWxSceneMissMap() {
      const map = {};
      (this.parentWxTemplateStatus.items || []).forEach((item) => {
        if (item.configured || !item.configSceneKey) return;
        map[item.configSceneKey] = true;
      });
      return map;
    },
    /** 部门配置左侧导航项。最后更新：2026-06-29 */
    deptConfigNavItems() {
      const items = [
        { name: 'base', label: '基础设置', icon: 'el-icon-setting' },
        { name: 'task', label: '任务与通知', icon: 'el-icon-bell' },
        { name: 'app', label: '移动端', icon: 'el-icon-mobile-phone' }
      ];
      // 钉钉校 / 微信校均展示「微信推送」配置（登录校验、场景、短信开关）
      if (this.deptConfigForm.SchType === 'DingDing'
        || this.deptConfigForm.SchType === 'WeiXin'
        || this.deptConfigForm.SchType === 'WeiXi') {
        items.push({ name: 'parentWechat', label: '微信推送', icon: 'el-icon-chat-line-round' });
      }
      items.push(
        { name: 'liveType', label: '人员类型', icon: 'el-icon-s-custom' },
        { name: 'faceCompare', label: '人脸比对', icon: 'el-icon-user' },
        { name: 'aliyun', label: '阿里云', icon: 'el-icon-cloudy' },
        { name: 'pay', label: '支付配置', icon: 'el-icon-wallet' }
      );
      return items;
    }
  },
  watch: {
    /** OSS 总开关关闭时，联动关闭各类型子开关。最后更新：2026-06-30 */
    'deptConfigForm.schoolOssEnabled'(val) {
      if (!val) {
        this.resetOssSubOptions();
        return;
      }
      this.fillDefaultOssEndpointIfEmpty();
    },
    /** 切到微信推送页时加载模板状态。创建于 2026-07-25 */
    deptConfigActiveTab(val) {
      if (val === 'parentWechat') {
        this.loadParentWeChatTemplateStatus();
      }
      if (val === 'pay') {
        this.loadSchoolPayConfig();
      }
      if (val === 'liveType') {
        this.loadLiveTypeConfig();
      }
    },
    /** 钉钉校修改 AppId 后防抖刷新模板状态。创建于 2026-07-25 */
    'deptConfigForm.parentPushWeChatAppId'() {
      if (this.deptConfigActiveTab !== 'parentWechat') return;
      if (this.parentWxTemplateStatusTimer) {
        clearTimeout(this.parentWxTemplateStatusTimer);
      }
      this.parentWxTemplateStatusTimer = setTimeout(() => {
        this.loadParentWeChatTemplateStatus();
      }, 400);
    }
  },
  methods: {
    /**
     * 人脸 / 车牌勾选状态对应的 AK 标签。创建于 2026-08-11
     * 未勾选 → 平台 AK；勾选且 AccessKey 配齐 → 本校 AK；勾选未配齐 → 未配齐（不回退平台）。
     */
    resolveFacePlateAkStatus(checked) {
      if (!checked) return { label: '平台 AK', cls: 'is-platform' };
      if (this.isSchoolAkPairComplete) return { label: '本校 AK', cls: 'is-school' };
      return { label: '未配齐', cls: 'is-warn' };
    },
    /**
     * 重置支付表单为空默认值（打开弹窗时先清空，避免串校）。创建于 2026-09-12
     */
    resetPayConfigForm() {
      this.payConfigLoaded = false;
      this.payConfigForm = {
        aliPayAppId: '',
        wxPayConfigId: null,
        enabledPayTypes: []
      };
    },
    /**
     * 加载学校支付配置。创建于 2026-08-07；最后修改：2026-09-12（打开弹窗即加载，返回 Promise 供保存等待）
     */
    loadSchoolPayConfig() {
      const schoolId = this.deptConfigForm && this.deptConfigForm.Id;
      if (!schoolId) {
        this.payConfigLoadPromise = Promise.resolve(false);
        return this.payConfigLoadPromise;
      }
      this.payConfigLoadPromise = Promise.all([
        getSchoolPayConfig({ schoolId }),
        getSchoolAliPayOptions(),
        getSchoolWxPayOptions()
      ]).then(([cfgRes, aliRes, wxRes]) => {
        // 弹窗已切到其他学校时丢弃过期响应
        if (!this.deptConfigForm || this.deptConfigForm.Id !== schoolId) return false;
        const cfg = cfgRes && cfgRes.data && cfgRes.data.response ? cfgRes.data.response : {};
        this.payConfigForm.aliPayAppId = cfg.aliPayAppId || cfg.AliPayAppId || '';
        this.payConfigForm.wxPayConfigId = cfg.wxPayConfigId != null ? cfg.wxPayConfigId : (cfg.WxPayConfigId != null ? cfg.WxPayConfigId : null);
        const enabled = cfg.enabledPayTypes || cfg.EnabledPayTypes || [];
        this.payConfigForm.enabledPayTypes = Array.isArray(enabled) ? enabled.map(n => Number(n)).filter(n => n === 1 || n === 2 || n === 3) : [];
        this.aliPayOptions = (aliRes && aliRes.data && aliRes.data.response) || [];
        this.wxPayOptions = (wxRes && wxRes.data && wxRes.data.response) || [];
        this.payConfigLoaded = true;
        return true;
      }).catch(() => {
        this.payConfigLoaded = false;
        return false;
      });
      return this.payConfigLoadPromise;
    },
    /** 支付通道是否启用。创建于 2026-08-07 */
    isPayChannelEnabled(payType) {
      return (this.payConfigForm.enabledPayTypes || []).indexOf(payType) >= 0;
    },
    /** 切换支付通道启用状态。创建于 2026-08-07 */
    togglePayChannel(payType) {
      const list = (this.payConfigForm.enabledPayTypes || []).slice();
      const idx = list.indexOf(payType);
      if (idx >= 0) list.splice(idx, 1);
      else list.push(payType);
      this.payConfigForm.enabledPayTypes = list;
    },
    /**
     * 保存前校验支付多选与商户绑定。创建于 2026-08-07
     */
    validatePayConfigBeforeSave() {
      const types = this.payConfigForm.enabledPayTypes || [];
      if (types.indexOf(1) >= 0 && !this.payConfigForm.wxPayConfigId) {
        this.$message.warning('启用微信时请选择微信支付商户配置');
        return false;
      }
      if (types.indexOf(2) >= 0 && !this.payConfigForm.aliPayAppId) {
        this.$message.warning('启用支付宝时请选择支付宝应用 AppId');
        return false;
      }
      return true;
    },
    /** 推送场景是否已勾选。创建于 2026-07-25 */
    isParentWxSceneChecked(sceneKey) {
      const list = this.deptConfigForm.parentPushWeChatSceneList || [];
      return list.indexOf(sceneKey) >= 0;
    },
    /** 整卡切换推送场景（避免只点到复选框小区域才生效）。创建于 2026-07-25 */
    toggleParentWxScene(sceneKey) {
      if (!this.deptConfigForm.parentPushWeChatEnabled) return;
      const list = (this.deptConfigForm.parentPushWeChatSceneList || []).slice();
      const idx = list.indexOf(sceneKey);
      if (idx >= 0) list.splice(idx, 1);
      else list.push(sceneKey);
      this.deptConfigForm.parentPushWeChatSceneList = list;
    },
    /**
     * 拉取家长微信标准模板配置状态（缺哪些）。创建于 2026-07-25
     */
    loadParentWeChatTemplateStatus() {
      const schoolId = this.deptConfigForm && this.deptConfigForm.Id;
      if (!schoolId) return;
      const requestSeq = ++this.parentWxTemplateStatusRequestSeq;
      this.parentWxTemplateStatusLoading = true;
      const params = { departmentId: schoolId };
      if (this.isDingDingSchoolForWechatPush) {
        const appId = (this.deptConfigForm.parentPushWeChatAppId || '').trim();
        if (appId) params.appId = appId;
      }
      getParentWeChatTemplateStatus(params)
        .then((res) => {
          if (requestSeq !== this.parentWxTemplateStatusRequestSeq) return;
          const data = res && res.data && res.data.response ? res.data.response : null;
          if (!data) {
            this.parentWxTemplateStatus = {
              appId: '',
              hasAppId: false,
              missingCount: 0,
              items: []
            };
            return;
          }
          this.parentWxTemplateStatus = {
            appId: data.appId || data.AppId || '',
            hasAppId: !!(data.hasAppId != null ? data.hasAppId : data.HasAppId),
            missingCount: data.missingCount != null ? data.missingCount : (data.MissingCount || 0),
            items: (data.items || data.Items || []).map((x) => ({
              name: x.name || x.Name,
              configSceneKey: x.configSceneKey || x.ConfigSceneKey,
              businessKey: x.businessKey || x.BusinessKey,
              sceneKey: x.sceneKey || x.SceneKey,
              configured: !!(x.configured != null ? x.configured : x.Configured),
              statusText: x.statusText || x.StatusText || ''
            }))
          };
        })
        .catch(() => {
          if (requestSeq !== this.parentWxTemplateStatusRequestSeq) return;
          this.parentWxTemplateStatus = {
            appId: '',
            hasAppId: false,
            missingCount: 0,
            items: []
          };
        })
        .finally(() => {
          if (requestSeq !== this.parentWxTemplateStatusRequestSeq) return;
          this.parentWxTemplateStatusLoading = false;
        });
    },
    /** 加载平台 OSS 默认 Bucket 配置（appsettings） */
    async loadOssPlatformDefaults() {
      try {
        const res = await getOssPlatformDefaults();
        if (res.data && res.data.success && res.data.response) {
          const data = res.data.response;
          this.ossPlatformDefaults = {
            DefaultEndpoint: data.DefaultEndpoint || data.defaultEndpoint || '',
            DefaultRegion: data.DefaultRegion || data.defaultRegion || 'oss-cn-shanghai',
            TypeEndpoints: data.TypeEndpoints || data.typeEndpoints || {}
          };
        }
      } catch (e) {
        // 静默失败，不影响手动填写
      }
    },
    /** 解析某类型的平台默认 Bucket：类型专用 → 平台默认 */
    resolveTypeDefaultEndpoint(typeItem) {
      if (!typeItem) return '';
      const typeMap = this.ossPlatformDefaults.TypeEndpoints || {};
      const configKey = typeItem.configKey;
      if (configKey && typeMap[configKey]) return typeMap[configKey];
      return this.ossPlatformDefaults.DefaultEndpoint || '';
    },
    /** 开启 OSS 总开关时，默认 Bucket 为空则填充平台默认 */
    fillDefaultOssEndpointIfEmpty() {
      if ((this.deptConfigForm.schoolAliyunOssEndpoint || '').trim()) return;
      const ep = this.ossPlatformDefaults.DefaultEndpoint;
      if (ep) this.deptConfigForm.schoolAliyunOssEndpoint = ep;
    },
    /** 是否已配置本校 OSS AK（含已保存 Secret，不要求 Bucket） */
    isSchoolOssAkConfigured() {
      return this.deptConfigForm.useSchoolAliyunForOss && this.isSchoolAkPairComplete;
    },
    /** 平台 appsettings 中的视频默认 Bucket（global-resource-video） */
    resolveVideoPlatformEndpoint() {
      const typeMap = this.ossPlatformDefaults.TypeEndpoints || {};
      return typeMap.Video || this.ossPlatformDefaults.DefaultEndpoint || '';
    },
    /** 视频 Bucket 输入框 placeholder：始终展示平台视频桶作参考 */
    resolveVideoBucketPlaceholder() {
      const platformVideo = this.resolveVideoPlatformEndpoint();
      if (this.isSchoolOssAkConfigured()) {
        const schoolDefault = (this.deptConfigForm.schoolAliyunOssEndpoint || '').trim();
        if (platformVideo) {
          return schoolDefault
            ? `留空用 ${schoolDefault}（平台参考：${platformVideo}）`
            : `留空用学校默认 Bucket（平台参考：${platformVideo}）`;
        }
        return schoolDefault ? `留空用 ${schoolDefault}` : '留空用学校默认 Bucket';
      }
      if (platformVideo) {
        return `留空用 ${platformVideo}`;
      }
      return '专用 Bucket（不填用平台/学校默认）';
    },
    /** 类型 Bucket 自动填充：本校 AK 且已有默认 Bucket 时优先用默认，否则用平台类型默认 */
    resolveTypeAutoFillEndpoint(typeItem) {
      const schoolDefault = (this.deptConfigForm.schoolAliyunOssEndpoint || '').trim();
      if (this.isSchoolOssAkConfigured() && schoolDefault) return schoolDefault;
      return this.resolveTypeDefaultEndpoint(typeItem);
    },
    /** 勾选某类型时，专用 Bucket 为空则自动填充 */
    onOssTypeSwitchChange(typeItem, enabled) {
      if (!enabled || !typeItem) return;
      const endpointKey = typeItem.endpointKey;
      if ((this.deptConfigForm[endpointKey] || '').trim()) return;
      const ep = this.resolveTypeAutoFillEndpoint(typeItem);
      if (ep) this.deptConfigForm[endpointKey] = ep;
    },
    /** 勾选视频直传时自动填充的实际 Bucket（非 placeholder） */
    resolveVideoAutoFillEndpoint() {
      const schoolDefault = (this.deptConfigForm.schoolAliyunOssEndpoint || '').trim();
      if (this.isSchoolOssAkConfigured() && schoolDefault) return schoolDefault;
      return this.resolveVideoPlatformEndpoint();
    },
    /** 勾选视频直传时，视频专用 Bucket 为空则自动填充 */
    onOssVideoSwitchChange(enabled) {
      if (!enabled) return;
      if ((this.deptConfigForm.schoolAliyunOssEndpointVideo || '').trim()) return;
      const ep = this.resolveVideoAutoFillEndpoint();
      if (ep) this.deptConfigForm.schoolAliyunOssEndpointVideo = ep;
    },
    /** 关闭 OSS 各类型子开关（视频直传 + 服务端转存）。最后更新：2026-06-30 */
    resetOssSubOptions() {
      this.deptConfigForm.useSchoolAliyunForOssVideo = false;
      this.ossTypeItems.forEach(item => {
        this.deptConfigForm[item.switchKey] = false;
      });
    },
    //部门配置 
    openDeptConfig(row) {
      this.deptConfigForm = {
        Id: row.Id,
        Name: row.Name,
        SchId: row.SchId || '',
        City: row.City || '110100', // 初始化城市字段
        schoolExpiredContactAdminMsg: row.SchoolExpiredContactAdminMsg || '学校服务已到期，请联系管理员。',
        MobileAllowEditUserType: typeof row.MobileAllowEditUserType === 'boolean'
          ? row.MobileAllowEditUserType
          : !!row.MobileAllowEditUserType,
        EnableOrderFood: typeof row.EnableOrderFood === 'boolean' ? row.EnableOrderFood : !!row.EnableOrderFood,
        TimeoutReturnSchoolNotice: typeof row.TimeoutReturnSchoolNotice === 'boolean' ? row.TimeoutReturnSchoolNotice : !!row.TimeoutReturnSchoolNotice,
        EnableDailyKaoqinSummaryPush: typeof row.EnableDailyKaoqinSummaryPush === 'boolean'
          ? row.EnableDailyKaoqinSummaryPush
          : (row.EnableDailyKaoqinSummaryPush === undefined ? false : !!row.EnableDailyKaoqinSummaryPush),
        DailyKaoqinSummaryPushTime: row.DailyKaoqinSummaryPushTime || '09:00',
        DailyKaoqinSummaryPushTaskId: row.DailyKaoqinSummaryPushTaskId || '',
        ShowLeaveReturnSchoolTime: typeof row.ShowLeaveReturnSchoolTime === 'boolean' ? row.ShowLeaveReturnSchoolTime : (row.ShowLeaveReturnSchoolTime === undefined ? false : !!row.ShowLeaveReturnSchoolTime), // 新增：初始化请假返校时间是否隐藏字段
        // 初始化自动获取新闻相关设置
        EnableAutoNewsFetch: typeof row.EnableAutoNewsFetch === 'boolean'
          ? row.EnableAutoNewsFetch
          : (row.EnableAutoNewsFetch === undefined ? false : !!row.EnableAutoNewsFetch),
        AutoNewsFetchTime: row.AutoNewsFetchTime || '07:00',
        AutoNewsFetchTaskId: row.AutoNewsFetchTaskId || '',
        TempNewsAuditRequireAll: typeof row.TempNewsAuditRequireAll === 'boolean'
          ? row.TempNewsAuditRequireAll
          : !!row.TempNewsAuditRequireAll,
        TempNewsDefaultValidDays: Number(row.TempNewsDefaultValidDays) > 0 ? Number(row.TempNewsDefaultValidDays) : 0,
        // 初始化推送设置
        EnablePushForSpecialType: typeof row.EnablePushForSpecialType === 'boolean' ? row.EnablePushForSpecialType : (row.EnablePushForSpecialType === undefined ? true : !!row.EnablePushForSpecialType),
        EnablePushForNormalType: typeof row.EnablePushForNormalType === 'boolean' ? row.EnablePushForNormalType : (row.EnablePushForNormalType === undefined ? true : !!row.EnablePushForNormalType),
        TeacherKaoQinPushEnabled: typeof row.TeacherKaoQinPushEnabled === 'boolean' ? row.TeacherKaoQinPushEnabled : (row.TeacherKaoQinPushEnabled === undefined ? true : !!row.TeacherKaoQinPushEnabled),
        CardControl: typeof row.CardControl === 'boolean' ? row.CardControl : !!row.CardControl,
        AvatarControl: typeof row.AvatarControl === 'boolean' ? row.AvatarControl : !!row.AvatarControl,
        SchType: row.SchType || '',
        parentPushWeChatEnabled: typeof row.ParentPushWeChatEnabled === 'boolean'
          ? row.ParentPushWeChatEnabled
          : !!row.ParentPushWeChatEnabled,
        parentPushWeChatDingTalkFallback: typeof row.ParentPushWeChatDingTalkFallback === 'boolean'
          ? row.ParentPushWeChatDingTalkFallback
          : !!row.ParentPushWeChatDingTalkFallback,
        // 缺省不兜底
        parentPushWeChatAppId: row.ParentPushWeChatAppId || '',
        parentPushWeChatSceneList: (row.ParentPushWeChatScenes || '')
          .split(',')
          .map(s => s.trim())
          .filter(s => s.length > 0),
        parentPushWeChatRequireSmsVerification: typeof row.ParentPushWeChatRequireSmsVerification === 'boolean'
          ? row.ParentPushWeChatRequireSmsVerification
          : (row.ParentPushWeChatRequireSmsVerification === undefined ? true : !!row.ParentPushWeChatRequireSmsVerification),
        parentWxBindEntryMode: (row.ParentWxBindEntryMode || '').trim() === 'PhoneFirst' ? 'PhoneFirst' : 'StudentFirst',

        OrganizationChart: row.OrganizationChart || '',

        useSchoolAliyunForFaceSearch: typeof row.UseSchoolAliyunForFaceSearch === 'boolean'
          ? row.UseSchoolAliyunForFaceSearch
          : !!row.UseSchoolAliyunForFaceSearch,
        useSchoolAliyunForLicensePlateOcr: typeof row.UseSchoolAliyunForLicensePlateOcr === 'boolean'
          ? row.UseSchoolAliyunForLicensePlateOcr
          : !!row.UseSchoolAliyunForLicensePlateOcr,
        useSchoolAliyunForOss: typeof row.UseSchoolAliyunForOss === 'boolean'
          ? row.UseSchoolAliyunForOss
          : !!row.UseSchoolAliyunForOss,
        schoolOssEnabled: typeof row.SchoolOssEnabled === 'boolean'
          ? row.SchoolOssEnabled
          : !!row.SchoolOssEnabled,
        useSchoolAliyunForOssImage: typeof row.UseSchoolAliyunForOssImage === 'boolean'
          ? row.UseSchoolAliyunForOssImage
          : !!row.UseSchoolAliyunForOssImage,
        useSchoolAliyunForOssAvatar: typeof row.UseSchoolAliyunForOssAvatar === 'boolean'
          ? row.UseSchoolAliyunForOssAvatar
          : !!row.UseSchoolAliyunForOssAvatar,
        useSchoolAliyunForOssAudio: typeof row.UseSchoolAliyunForOssAudio === 'boolean'
          ? row.UseSchoolAliyunForOssAudio
          : !!row.UseSchoolAliyunForOssAudio,
        useSchoolAliyunForOssDocument: typeof row.UseSchoolAliyunForOssDocument === 'boolean'
          ? row.UseSchoolAliyunForOssDocument
          : !!row.UseSchoolAliyunForOssDocument,
        useSchoolAliyunForOssAttendance: typeof row.UseSchoolAliyunForOssAttendance === 'boolean'
          ? row.UseSchoolAliyunForOssAttendance
          : !!row.UseSchoolAliyunForOssAttendance,
        useSchoolAliyunForOssCameraVideo: typeof row.UseSchoolAliyunForOssCameraVideo === 'boolean'
          ? row.UseSchoolAliyunForOssCameraVideo
          : !!row.UseSchoolAliyunForOssCameraVideo,
        useSchoolAliyunForOssLog: typeof row.UseSchoolAliyunForOssLog === 'boolean'
          ? row.UseSchoolAliyunForOssLog
          : !!row.UseSchoolAliyunForOssLog,
        schoolAliyunOssEndpointImage: row.SchoolAliyunOssEndpointImage || '',
        schoolAliyunOssEndpointAvatar: row.SchoolAliyunOssEndpointAvatar || '',
        schoolAliyunOssEndpointAudio: row.SchoolAliyunOssEndpointAudio || '',
        schoolAliyunOssEndpointDocument: row.SchoolAliyunOssEndpointDocument || '',
        schoolAliyunOssEndpointAttendance: row.SchoolAliyunOssEndpointAttendance || '',
        schoolAliyunOssEndpointCameraVideo: row.SchoolAliyunOssEndpointCameraVideo || '',
        schoolAliyunOssEndpointLog: row.SchoolAliyunOssEndpointLog || '',
        schoolAliyunOssEndpointVideo: row.SchoolAliyunOssEndpointVideo || '',
        schoolAliyunAccessKeyId: row.SchoolAliyunAccessKeyId || '',
        schoolAliyunAccessKeySecret: row.SchoolAliyunAccessKeySecret || row.schoolAliyunAccessKeySecret || '',
        schoolAliyunAccessKeySecretPresent: row.SchoolAliyunAccessKeySecretPresent === true
          || row.schoolAliyunAccessKeySecretPresent === true,
        schoolAliyunFaceBodyEndpoint: row.SchoolAliyunFaceBodyEndpoint || '',
        schoolAliyunOcrEndpoint: row.SchoolAliyunOcrEndpoint || '',
        schoolAliyunOssEndpoint: row.SchoolAliyunOssEndpoint || '',
        schoolAliyunOssObjectPrefix: row.SchoolAliyunOssObjectPrefix || '',
        useSchoolAliyunForOssVideo: typeof row.UseSchoolAliyunForOssVideo === 'boolean'
          ? row.UseSchoolAliyunForOssVideo
          : !!row.UseSchoolAliyunForOssVideo,
        schoolAliyunStsRoleArn: row.SchoolAliyunStsRoleArn || '',
        enableFaceCompare: typeof row.EnableFaceCompare === 'boolean'
          ? row.EnableFaceCompare
          : (row.EnableFaceCompare === undefined ? false : !!row.EnableFaceCompare)
      };
      // 根据城市code设置城市选择路径
      const cityCode = row.City || '110100';
      this.cityPath = this.getCityPathByCode(cityCode);
      this.showSchoolAliyunAccessKeyId = false;
      this.showSchoolAliyunAccessKeySecret = false;
      // 打开即预加载支付配置：统一「保存配置」会一并提交支付，未加载时空默认值会清空库内商户/通道。最后更新：2026-09-12
      this.resetPayConfigForm();
      this.loadSchoolPayConfig();
      this.deptConfigDialogVisible = true;
    },

    /** 打开部门配置弹窗：重置页签并禁止页面滚动。创建于 2026-08-07 */
    onDeptConfigDialogOpen() {
      this.deptConfigActiveTab = 'base';
      document.body.classList.add('dept-config-dialog-open');
      this.$nextTick(() => {
        const dialog = document.querySelector('.el-dialog.dept-config-dialog');
        const wrapper = dialog && dialog.closest('.el-dialog__wrapper');
        if (wrapper) wrapper.style.overflow = 'hidden';
      });
    },
    /** 关闭部门配置弹窗后恢复页面滚动。创建于 2026-08-07 */
    onDeptConfigDialogClosed() {
      document.body.classList.remove('dept-config-dialog-open');
      const dialog = document.querySelector('.el-dialog.dept-config-dialog');
      const wrapper = dialog && dialog.closest('.el-dialog__wrapper');
      if (wrapper) wrapper.style.overflow = '';
    },

    /**
     * 加载本校人员类型命名。最后更新：2026-09-15
     */
    async loadLiveTypeConfig() {
      const schId = (this.deptConfigForm.SchId || '').trim();
      if (!schId) {
        this.liveTypeItems = [];
        this.liveTypeIsDefault = false;
        this.$message.warning('当前机构缺少学校ID，无法配置人员类型');
        return;
      }
      this.liveTypeLoading = true;
      try {
        const res = await getStudentLiveTypeBySchId({ schId });
        if (res.data && res.data.success) {
          this.liveTypeItems = (res.data.response || []).map((item) => ({
            LiveTypeId: item.LiveTypeId || item.liveTypeId || '',
            LiveTypeName: item.LiveTypeName || item.liveTypeName || '',
            DefaultLiveTypeName: item.DefaultLiveTypeName || item.defaultLiveTypeName || '',
            IsDefault: !!(item.IsDefault || item.isDefault)
          }));
          this.liveTypeIsDefault = this.liveTypeItems.some((x) => x.IsDefault);
        } else {
          this.$message.error((res.data && res.data.msg) || '加载人员类型失败');
        }
      } catch (e) {
        this.$message.error('加载人员类型失败');
      } finally {
        this.liveTypeLoading = false;
      }
    },
    /**
     * 单独保存本校人员类型命名。最后更新：2026-09-15
     */
    async saveLiveTypeConfig() {
      const schId = (this.deptConfigForm.SchId || '').trim();
      if (!schId) {
        this.$message.warning('当前机构缺少学校ID，无法保存');
        return;
      }
      const items = (this.liveTypeItems || []).map((item) => ({
        LiveTypeId: item.LiveTypeId,
        LiveTypeName: (item.LiveTypeName || '').trim()
      }));
      if (!items.length || items.some((x) => !x.LiveTypeName)) {
        this.$message.warning('请填写全部人员类型名称');
        return;
      }
      this.liveTypeSaving = true;
      try {
        const res = await saveStudentLiveType({ SchId: schId, Items: items });
        if (res.data && res.data.success) {
          this.$message.success((res.data && res.data.msg) || '保存成功');
          await this.loadLiveTypeConfig();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      } catch (e) {
        this.$message.error('保存人员类型失败');
      } finally {
        this.liveTypeSaving = false;
      }
    },
    /**
     * 保存部门配置（含支付）。支付未加载完成时先等待，避免空默认值覆盖。最后修改：2026-09-12
     */
    async saveDeptConfig() {
      if (!this.deptConfigForm.schoolOssEnabled) {
        this.resetOssSubOptions();
      }
      this.deptConfigLoading = true;
      try {
        // 未点过「支付配置」时也可能立刻点保存：必须等预加载完成后再提交支付
        if (!this.payConfigLoaded) {
          const loaded = await (this.payConfigLoadPromise || this.loadSchoolPayConfig());
          if (!loaded) {
            this.$message.error('支付配置加载失败，请稍后重试或先打开「支付配置」页签');
            return;
          }
        }
        if (!this.validatePayConfigBeforeSave()) return;

        const schoolId = this.deptConfigForm.Id;
        const [res, payRes] = await Promise.all([
          setOrderFood({
            SchoolId: schoolId,
            City: this.deptConfigForm.City,
            SchoolExpiredContactAdminMsg: (this.deptConfigForm.schoolExpiredContactAdminMsg || '').trim()
              || '学校服务已到期，请联系管理员。',
            CardControl: this.deptConfigForm.CardControl,
            AvatarControl: this.deptConfigForm.AvatarControl,
            MobileAllowEditUserType: this.deptConfigForm.MobileAllowEditUserType,
            EnableOrderFood: this.deptConfigForm.EnableOrderFood,
            TimeoutReturnSchoolNotice: this.deptConfigForm.TimeoutReturnSchoolNotice,
            EnableDailyKaoqinSummaryPush: this.deptConfigForm.EnableDailyKaoqinSummaryPush,
            DailyKaoqinSummaryPushTime: this.deptConfigForm.DailyKaoqinSummaryPushTime,
            // 推送相关参数
            EnablePushForSpecialType: this.deptConfigForm.EnablePushForSpecialType,
            EnablePushForNormalType: this.deptConfigForm.EnablePushForNormalType,
            TeacherKaoQinPushEnabled: this.deptConfigForm.TeacherKaoQinPushEnabled,
            ParentPushWeChatForScenes: (this.deptConfigForm.parentPushWeChatSceneList || []).join(','),
            ParentPushWeChatAppId: (this.deptConfigForm.parentPushWeChatAppId || '').trim(),
            ParentPushWeChatEnabled: this.deptConfigForm.parentPushWeChatEnabled,
            ParentPushWeChatDingTalkFallback: this.deptConfigForm.parentPushWeChatDingTalkFallback,
            ParentPushWeChatRequireSmsVerification: this.deptConfigForm.parentPushWeChatRequireSmsVerification,
            ParentWxBindEntryMode: this.deptConfigForm.parentWxBindEntryMode || 'StudentFirst',
            ShowLeaveReturnSchoolTime: this.deptConfigForm.ShowLeaveReturnSchoolTime,
            // 自动获取新闻相关参数
            EnableAutoNewsFetch: this.deptConfigForm.EnableAutoNewsFetch,
            AutoNewsFetchTime: this.deptConfigForm.AutoNewsFetchTime,
            TempNewsAuditRequireAll: this.deptConfigForm.TempNewsAuditRequireAll,
            TempNewsDefaultValidDays: Number(this.deptConfigForm.TempNewsDefaultValidDays) > 0
              ? Number(this.deptConfigForm.TempNewsDefaultValidDays)
              : 0,
            OrganizationChart: this.deptConfigForm.OrganizationChart,
            UseSchoolAliyunForFaceSearch: this.deptConfigForm.useSchoolAliyunForFaceSearch,
            UseSchoolAliyunForLicensePlateOcr: this.deptConfigForm.useSchoolAliyunForLicensePlateOcr,
            UseSchoolAliyunForOss: this.deptConfigForm.useSchoolAliyunForOss,
            SchoolOssEnabled: this.deptConfigForm.schoolOssEnabled,
            UseSchoolAliyunForOssImage: this.deptConfigForm.useSchoolAliyunForOssImage,
            UseSchoolAliyunForOssAvatar: this.deptConfigForm.useSchoolAliyunForOssAvatar,
            UseSchoolAliyunForOssAudio: this.deptConfigForm.useSchoolAliyunForOssAudio,
            UseSchoolAliyunForOssDocument: this.deptConfigForm.useSchoolAliyunForOssDocument,
            UseSchoolAliyunForOssAttendance: this.deptConfigForm.useSchoolAliyunForOssAttendance,
            UseSchoolAliyunForOssCameraVideo: this.deptConfigForm.useSchoolAliyunForOssCameraVideo,
            UseSchoolAliyunForOssLog: this.deptConfigForm.useSchoolAliyunForOssLog,
            SchoolAliyunOssEndpointImage: (this.deptConfigForm.schoolAliyunOssEndpointImage || '').trim(),
            SchoolAliyunOssEndpointAvatar: (this.deptConfigForm.schoolAliyunOssEndpointAvatar || '').trim(),
            SchoolAliyunOssEndpointAudio: (this.deptConfigForm.schoolAliyunOssEndpointAudio || '').trim(),
            SchoolAliyunOssEndpointDocument: (this.deptConfigForm.schoolAliyunOssEndpointDocument || '').trim(),
            SchoolAliyunOssEndpointAttendance: (this.deptConfigForm.schoolAliyunOssEndpointAttendance || '').trim(),
            SchoolAliyunOssEndpointCameraVideo: (this.deptConfigForm.schoolAliyunOssEndpointCameraVideo || '').trim(),
            SchoolAliyunOssEndpointLog: (this.deptConfigForm.schoolAliyunOssEndpointLog || '').trim(),
            SchoolAliyunOssEndpointVideo: (this.deptConfigForm.schoolAliyunOssEndpointVideo || '').trim(),
            SchoolAliyunAccessKeyId: (this.deptConfigForm.schoolAliyunAccessKeyId || '').trim(),
            SchoolAliyunAccessKeySecret: (this.deptConfigForm.schoolAliyunAccessKeySecret || '').trim(),
            SchoolAliyunFaceBodyEndpoint: (this.deptConfigForm.schoolAliyunFaceBodyEndpoint || '').trim(),
            // 车牌 OCR 域名由平台固定，保存时清空学校自定义（含旧版 ocr.cn-*）
            SchoolAliyunOcrEndpoint: '',
            SchoolAliyunOssEndpoint: (this.deptConfigForm.schoolAliyunOssEndpoint || '').trim(),
            SchoolAliyunOssObjectPrefix: (this.deptConfigForm.schoolAliyunOssObjectPrefix || '').trim(),
            UseSchoolAliyunForOssVideo: this.deptConfigForm.useSchoolAliyunForOssVideo,
            SchoolAliyunStsRoleArn: (this.deptConfigForm.schoolAliyunStsRoleArn || '').trim(),
            EnableFaceCompare: this.deptConfigForm.enableFaceCompare
          }),
          saveSchoolPayConfig({
            SchoolId: schoolId,
            AliPayAppId: this.payConfigForm.aliPayAppId || '',
            WxPayConfigId: this.payConfigForm.wxPayConfigId || null,
            EnabledPayTypes: this.payConfigForm.enabledPayTypes || []
          })
        ]);
        const deptOk = res && res.data && res.data.success;
        const payOk = payRes && payRes.data && payRes.data.success;
        if (deptOk && payOk) {
          this.$message.success('保存成功');
          this.deptConfigDialogVisible = false;
          this.handleQuery();
        } else {
          const msg = (!deptOk && res && res.data && res.data.msg)
            || (!payOk && payRes && payRes.data && payRes.data.msg)
            || '保存失败';
          this.$message.error(msg);
        }
      } catch (e) {
        this.$message.error('保存失败，请稍后重试');
      } finally {
        this.deptConfigLoading = false;
      }
    },
    // 城市选择变化处理
    handleCityChange(value) {
      console.log('城市选择变化:', value);
      if (value && value.length > 0) {
        // 保存城市code
        this.deptConfigForm.City = value[value.length - 1];
      } else {
        this.deptConfigForm.City = '';
      }
    },
    // 根据城市code获取城市路径
    getCityPathByCode(code) {
      if (!code) return [];

      const findPath = (data, code, path = []) => {
        for (const item of data) {
          // 检查当前层级是否匹配
          if (item.code === code) {
            return [...path, item.code];
          }

          // 先检查城市层级
          if (item.cities && item.cities.length > 0) {
            const cityResult = findPath(item.cities, code, [...path, item.code]);
            if (cityResult.length > 0) {
              return cityResult;
            }
          }

          // 再检查区县层级
          if (item.districts && item.districts.length > 0) {
            const districtResult = findPath(item.districts, code, [...path, item.code]);
            if (districtResult.length > 0) {
              return districtResult;
            }
          }
        }
        return [];
      };

      // 调试：打印传入的code和查找结果
      console.log('查找城市code:', code);
      const result = findPath(this.cityData, code);
      console.log('查找结果:', result);

      return result;
    },

    handleLogoChange(file) {
      this.deferredImageChange('logo', file, { foo: 'Department', savedUrl: this.imageUrl })
    },

    // ----------- 新增组织架构图上传相关方法 -----------
    handleUploadOrgChartSuccess(res, file) {
      if (res.success) {
        // 保存带域名的全路径以便预览无忧
        this.deptConfigForm.OrganizationChart = this.$resolveImageSrc(res.response);
        this.$message.success('组织架构图上传成功');
      } else {
        this.$message.error(res.msg || '上传图片失败');
      }
    },
    beforeUploadOrgChart(file) {
      const isImage = file.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error('只支持上传图片格式文件!');
      }
      if (!isLt5M) {
        this.$message.error('由于由于展示长图占比大，架构图最大支持限制在 10MB，当前偏大!');
      }
      return isImage && isLt5M;
    },
    getOrgChartPath(path) {
      if (!path) return '';
      if (path.startsWith('http')) {
        return path;
      }
      if (path.startsWith('/organizationChart/')) {
        return this.$resolveImageSrc(path);
      }
      let pureFileName = path.startsWith('/static/') ? path.replace('/static/', '/') : path;
      if (!pureFileName.startsWith('/')) {
        pureFileName = '/' + pureFileName;
      }
      return this.$resolveImageSrc('/organizationChart' + pureFileName);
    },
    // ----------- 新增组织架构图上传相关方法结束 -----------

    // 格式化状态显示
    formatStatus(status) {
      if (status === 'WeiXin') {
        return '微信'
      } else if (status === 'DingDing') {
        return '钉钉'
      } else {
        return ''
      }
    },

    getDateColor(date) {
      // 与后端 SchoolExpireHelper 一致：按日期比较，到期当天不标红。最后更新：2026-09-03
      if (!date || String(date).trim() === '') {
        return '';
      }
      const compareDate = new Date(String(date).trim());
      if (Number.isNaN(compareDate.getTime())) {
        return '';
      }
      const today = new Date();
      const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const expireDate = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());
      if (todayDate > expireDate) {
        return 'red';
      }
      return '';
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search === 'object' && item.search !== null) {
        this.filters = {
          name: item.search.name || '',
          schId: item.search.schId || '',
          schType: item.search.schType == null ? '' : String(item.search.schType),
          enableOrderFood: item.search.enableOrderFood == null ? '' : String(item.search.enableOrderFood),
          expired: item.search.expired == null ? '' : String(item.search.expired),
        };
      } else {
        this.filters = {
          name: item.search || '',
          schId: '',
          schType: '',
          enableOrderFood: '',
          expired: '',
        };
      }
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatModifyTime: function (row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.ModifyTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.page = 1;
      this.handleQuery();
    },
    /**
     * 导出当前筛选条件下的机构列表。创建于 2026-09-23
     */
    async exportExcel() {
      try {
        const para = {
          key: this.filters.name || '',
          schId: this.filters.schId || '',
          schType: this.filters.schType || '',
          enableOrderFood: this.filters.enableOrderFood || '',
          expired: this.filters.expired || '',
        };
        const response = await exportSchoolTreeTable(para);
        if (!response.data) {
          this.$message({ message: '导出数据为空', type: 'error' });
          return;
        }
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '机构列表.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message({ message: '导出失败', type: 'error' });
      }
    },
    load(tree, treeNode, resolve) {
      let para = {
        page: this.page,
        pageSize: this.PageSize,
        f: tree.Id,
        key: this.filters.name,
        schId: this.filters.schId || '',
        schType: this.filters.schType || '',
        enableOrderFood: this.filters.enableOrderFood || '',
        expired: this.filters.expired || '',
      };
      getSchTreeTable(para).then((res) => {
        resolve(res.data.response);
      });
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        pageSize: this.PageSize,
        key: this.filters.name,
        schId: this.filters.schId || '',
        schType: this.filters.schType || '',
        enableOrderFood: this.filters.enableOrderFood || '',
        expired: this.filters.expired || '',
      };
      this.listLoading = true;

      //NProgress.start();
      getSchTreeTable(para).then(async (res) => {
        const pageModel = res.data.response || {};
        this.total = pageModel.dataCount || 0;
        if (pageModel.pageSize) {
          this.PageSize = pageModel.pageSize;
        } else if (pageModel.PageSize) {
          this.PageSize = pageModel.PageSize;
        }
        const rows = pageModel.data || [];
        await this.prefetchListOssMedia(rows, 'Logo');
        this.users = rows;
        this.listLoading = false;
        this.totalCount = res.data.response.dataCount || 0;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeDepartment(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let that = this;

      that.options = [];

      this.editForm = {};

      that.editFormVisible = true;

      that.editForm = Object.assign({}, row);
      that.editFormOriginalSchId = (row.SchId || "").trim();
      this.imageUrl = this.editForm.Logo
      this.deferredImageInit('logo', this.editForm.Logo)
    },
    //显示新增界面
    handleAdd() {
      this.options = [];
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        Name: "",
        CodeRelationship: "",
        OrderSort: 0,
        Leader: "",
        Enabled: true,
        Status: false,
        SchId: "",
        SchType: "WeiXin",
        ThirdPartId: "",
        Address: "",
        IsCompany: false,
        ExpirationDate: '',
        DeptOrgType: "school",
        IsSyncTb: '0', //是否同步天波
        TbThirdPartId: '', // 天波第三方ID
        Logo: ''
      };
      this.imageUrl = ''
      this.deferredImageRevoke('logo')
    },
    //编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.editLoading = true;
            //NProgress.start();
            this.editForm.Logo = await this.deferredImageEnsure('logo', { foo: 'Department', currentUrl: this.editForm.Logo })
            let para = Object.assign({}, this.editForm);

            para.PidArr = [0];

            para.CodeRelationship = para.PidArr.join() + ",";

            para.ModifyTime = util.formatDate.format(
              new Date(),
              "yyyy-MM-dd hh:mm:ss"
            );

            para.Pid = para.PidArr.pop();

            if (para.Id == para.Pid) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error",
              });

              this.editLoading = false;
              return;
            }
            editDepartment(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              this.editLoading = false;
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.$refs.table.setCurrentRow();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit() {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.addLoading = true;
            //NProgress.start();
            this.addForm.Logo = await this.deferredImageEnsure('logo', { foo: 'Department', currentUrl: this.addForm.Logo })
            let para = Object.assign({}, this.addForm);

            para.PidArr = [0];

            para.CodeRelationship = para.PidArr.join() + ",";

            para.CreateTime = util.formatDate.format(
              new Date(),
              "yyyy-MM-dd hh:mm:ss"
            );
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            para.Pid = para.PidArr.pop();

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addDepartment(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    // 处理订餐状态切换
    handleOrderFoodToggle(row) {

      const SchoolId = row.Id;
      const currentStatus = row.EnableOrderFood;
      const newStatus = !currentStatus;
      const statusText = newStatus ? '开启' : '关闭';

      // 显示确认对话框
      this.$confirm(`确定要${statusText} ${row.Name} 的订餐功能吗？`, '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击确定，调用setOrderFood接口
        this.listLoading = true;
        setOrderFood({
          SchoolId: SchoolId,
          EnableOrderFood: newStatus
        }).then(res => {
          this.listLoading = false;

          if (res.data && res.data.success) {
            // 更新本地数据，避免刷新页面
            row.EnableOrderFood = newStatus;
            this.$message({
              message: `订餐功能${statusText}成功`,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data && res.data.msg ? res.data.msg : `订餐功能${statusText}失败`,
              type: 'error'
            });
          }
        }).catch(error => {
          this.listLoading = false;
          this.$message({
            message: `操作失败：${error.message || '未知错误'}`,
            type: 'error'
          });
        });
      }).catch(() => {
        // 用户点击取消
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  },
  mounted() {
    this.handleQuery();
    this.loadOssPlatformDefaults();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some((b) => b.Func === 'exportExcel')) {
      this.buttonList.push({ name: '导出', Func: 'exportExcel' });
    }
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 列表列宽：单行省略，长 ID 等宽字体便于扫读。最后修改：2026-09-13 */
.custom-tbl /deep/ .el-table__body .cell {
  line-height: 22px;
}

.custom-tbl /deep/ .col-mono .cell {
  font-family: Consolas, "SF Mono", Menlo, Monaco, monospace;
  font-size: 12px;
  letter-spacing: -0.2px;
}

.custom-tbl /deep/ .tbl-status-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* 机构新增/编辑：表单提示与两列间距。最后修改：2026-09-23 */
.dept-org-form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}

.dept-org-form /deep/ .el-form-item {
  margin-bottom: 16px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

/* 部门配置弹窗内部布局（shell/nav/content 带 data-v，scoped 生效） */
.dept-config-titlebar-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dept-config-titlebar-name {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.dept-config-titlebar-tag {
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 2px 10px;
  border-radius: 20px;
}

.dept-config-shell {
  display: flex;
  align-items: stretch;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.dept-config-nav {
  width: 168px;
  flex-shrink: 0;
  background: #f8f9fb;
  border-right: 1px solid #eef0f3;
  padding: 14px 10px;
  overflow-x: hidden;
  overflow-y: auto;
}

.dept-config-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 4px;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;
  user-select: none;
}

.dept-config-nav-item i {
  font-size: 15px;
  width: 18px;
  text-align: center;
  color: #9ca3af;
}

.dept-config-nav-item:hover {
  background: #eef2f7;
  color: #374151;
}

.dept-config-nav-item.is-active {
  background: #fff;
  color: #2563eb;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}

.dept-config-nav-item.is-active i {
  color: #2563eb;
}

.dept-config-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 20px 24px 24px;
  background: #f4f6f9;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* 各配置页在固定高度内由外层 content 统一滚动 */
.cfg-page {
  min-height: 100%;
  box-sizing: border-box;
}

/* 配置页内容区 */
.cfg-page-head {
  margin-bottom: 16px;
}

.cfg-page-head h4 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}

.cfg-page-head p {
  margin: 0;
  font-size: 13px;
  color: #9ca3af;
}

.cfg-group {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 14px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.cfg-group-label {
  padding: 11px 18px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.02em;
  background: #f9fafb;
  border-bottom: 1px solid #f0f2f5;
}

.cfg-group-label--with-tip,
.cfg-group-label--between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cfg-group-sublabel {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  font-weight: 400;
  color: #9ca3af;
  letter-spacing: 0;
}

.cfg-group-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.cfg-source-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

.cfg-tip-icon {
  color: #93c5fd;
  cursor: pointer;
  font-size: 14px;
}

.cfg-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid #f3f4f6;
}

.cfg-item:last-child {
  border-bottom: none;
}

.cfg-item--top {
  align-items: flex-start;
}

.cfg-item--stack {
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}

.cfg-item-text {
  flex: 1;
  min-width: 0;
}

.cfg-item-control {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.cfg-label {
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
}

.cfg-item--live-type .cfg-live-type-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cfg-live-type-default {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
  white-space: nowrap;
}

.cfg-desc {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.35;
}

.cfg-inline-label {
  font-size: 12px;
  color: #6b7280;
}

.cfg-checkbox-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

/* —— 微信推送页：分区 + 场景网格 + 模板标签。创建于 2026-07-25 —— */
.cfg-page--wx .cfg-group {
  margin-bottom: 12px;
}

.cfg-wx-appid-input {
  max-width: 420px;
}

.cfg-wx-appid-chip {
  display: inline-block;
  max-width: 280px;
  padding: 4px 10px;
  border-radius: 4px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 12px;
  font-family: Consolas, Monaco, monospace;
  word-break: break-all;
  line-height: 1.4;
}

.cfg-wx-scenes {
  padding-top: 10px;
  padding-bottom: 16px;
}

.cfg-wx-hint {
  margin: 0 0 10px;
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.5;
}

.cfg-wx-hint-danger {
  color: #f56c6c;
  font-weight: 500;
}

.cfg-wx-scene-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
  gap: 8px;
  width: 100%;
}

.cfg-wx-scene-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  user-select: none;
}

.cfg-wx-scene-card:hover:not(:disabled):not(.is-disabled) {
  border-color: #93c5fd;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.08);
}

.cfg-wx-scene-card.is-checked {
  border-color: #60a5fa;
  background: #eff6ff;
}

.cfg-wx-scene-card.is-miss.is-checked {
  border-color: #f0c78a;
  background: #fffbeb;
}

.cfg-wx-scene-card:disabled,
.cfg-wx-scene-card.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.cfg-wx-scene-check {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #c0c4cc;
  border-radius: 3px;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  box-sizing: border-box;
}

.cfg-wx-scene-card.is-checked .cfg-wx-scene-check {
  border-color: var(--btn-primary, #2563eb);
  background: var(--btn-primary, #2563eb);
}

.cfg-wx-scene-label {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #374151;
  line-height: 1.3;
}

.cfg-wx-scene-badge {
  flex-shrink: 0;
  padding: 0 6px;
  border-radius: 8px;
  background: #f59e0b;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  white-space: nowrap;
  pointer-events: none;
}

.cfg-wx-ready {
  padding: 12px 18px 16px;
  min-height: 48px;
}

.cfg-wx-ready-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.45;
  color: #374151;
}

.cfg-wx-ready-banner i {
  margin-top: 2px;
  font-size: 16px;
  flex-shrink: 0;
}

.cfg-wx-ready-banner.is-warn {
  background: #fffbeb;
  color: #92400e;
}

.cfg-wx-ready-banner.is-ok {
  background: #ecfdf5;
  color: #065f46;
}

.cfg-wx-ready-banner em {
  font-style: normal;
  opacity: 0.7;
  font-size: 12px;
  word-break: break-all;
}

.cfg-wx-ready-block {
  margin-top: 12px;
}

.cfg-wx-ready-caption {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.cfg-wx-toggle {
  border: none;
  background: none;
  padding: 0;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
}

.cfg-wx-toggle:hover {
  text-decoration: underline;
}

.cfg-wx-tag-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cfg-wx-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.4;
  border: 1px solid transparent;
}

.cfg-wx-tag.is-miss {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.cfg-wx-tag.is-ok {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
}

.cfg-radio-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 20px;
}

.cfg-radio-row .el-radio {
  margin-right: 0;
}

.cfg-form-grid {
  display: grid;
  gap: 14px;
  padding: 16px 18px;
}

.cfg-form-grid--single {
  grid-template-columns: 1fr;
}

.cfg-form-field /deep/ .el-input {
  width: 100%;
}

.cfg-form-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.cfg-form-field label em {
  font-style: normal;
  color: #d1d5db;
  font-weight: 400;
}

.cfg-form-field-hint {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #9ca3af;
}

.cfg-form-field--section {
  padding-top: 4px;
  border-top: 1px dashed #e5e7eb;
  margin-top: 4px;
}

.cfg-inline-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.cfg-inline-section-desc {
  margin: 4px 0 0;
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.4;
}

.cfg-subsection {
  padding: 0 18px 16px;
  border-top: 1px solid #f3f4f6;
}

.cfg-subsection-title {
  padding: 12px 0 4px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.cfg-subsection-desc {
  margin: 0 0 10px;
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.4;
}

.cfg-subsection--flush-top {
  margin-top: 0;
}

.cfg-item--in-subsection {
  padding-left: 0;
  padding-right: 0;
}

.cfg-item--in-subsection:first-of-type {
  padding-top: 0;
}

.cfg-form-grid--flush {
  padding: 0;
}

.cfg-inline-alert {
  margin: 0 18px 16px;
  padding: 8px 12px;
}

.cfg-field-hint {
  margin: 0 18px 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #9ca3af;
}

.cfg-field-hint--warn {
  color: #d97706;
}

.aliyun-oss-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.aliyun-toolbar-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.aliyun-toolbar-divider {
  width: 1px;
  height: 16px;
  background: #e5e7eb;
}

.aliyun-ak-tag {
  display: inline-block;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  border-radius: 999px;
  border: 1px solid transparent;
  vertical-align: middle;
}

.aliyun-ak-tag.is-inline {
  margin-left: 4px;
  transform: translateY(-1px);
}

.aliyun-ak-tag.is-platform {
  color: #7c5c10;
  background: #fffbeb;
  border-color: #fcd34d;
}

.aliyun-ak-tag.is-school {
  color: #047857;
  background: #ecfdf5;
  border-color: #6ee7b7;
}

.aliyun-ak-tag.is-warn {
  color: #b45309;
  background: #fff7ed;
  border-color: #fdba74;
}

.aliyun-oss-toolbar /deep/ .el-checkbox {
  margin-right: 0;
}

.aliyun-oss-toolbar /deep/ .el-checkbox__label {
  font-size: 12px;
  padding-left: 6px;
}

.cfg-group-label--ak {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.cfg-group-label-text .cfg-group-sublabel {
  margin-top: 2px;
}

.aliyun-service-tags {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.aliyun-service-item {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
}

.aliyun-service-tags /deep/ .el-checkbox.is-bordered {
  margin: 0;
  padding: 4px 10px;
  height: auto;
  border-radius: 6px;
}

.cfg-eye-icon {
  cursor: pointer;
  margin-right: 6px;
  color: #9ca3af;
}

.aliyun-ak-input.aliyun-ak-password-input /deep/ .el-input__inner {
  -webkit-text-security: disc !important;
}

.aliyun-type-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.aliyun-type-chip {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fafafa;
  transition: border-color 0.15s, background 0.15s;
}

.aliyun-type-chip.is-active {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.aliyun-type-bucket-input {
  margin-top: 8px;
  width: 100%;
}

.aliyun-type-bucket-input /deep/ .el-input__inner {
  font-size: 12px;
}

/* 支付配置：通道卡片 */
.cfg-pay-channel-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 14px 18px 16px;
}

.cfg-pay-channel-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 12px 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  user-select: none;
  min-height: 72px;
}

.cfg-pay-channel-card:hover {
  border-color: #93c5fd;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.08);
}

.cfg-pay-channel-card.is-checked {
  border-color: #60a5fa;
  background: #eff6ff;
}

.cfg-pay-channel-check {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

.cfg-pay-channel-card.is-checked .cfg-pay-channel-check {
  border-color: #2563eb;
  background: #2563eb;
}

.cfg-pay-channel-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.cfg-pay-channel-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}

.cfg-pay-channel-desc {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.45;
}

.cfg-pay-jl-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.55;
}

.cfg-pay-jl-note > i {
  margin-top: 2px;
  color: #3b82f6;
  font-size: 14px;
}

.cfg-pay-jl-note strong {
  font-weight: 600;
  color: #111827;
}

.cfg-pay-jl-note em {
  font-style: normal;
  font-weight: 600;
  color: #1d4ed8;
}

@media (max-width: 900px) {
  .cfg-pay-channel-grid {
    grid-template-columns: 1fr;
  }

  /* 双栏 / 头栏 / 表单项竖排已由 admin-responsive 全局覆盖，此处仅保留支付网格 */
}
</style>

<!-- 弹窗挂到 body，必须非 scoped，否则固定高度不生效，会变成整页滚动 -->
<style>
body.dept-config-dialog-open {
  overflow: hidden !important;
}

.el-dialog__wrapper:has(.dept-config-dialog) {
  overflow: hidden !important;
}

.el-dialog.dept-config-dialog,
.dept-config-dialog {
  height: min(720px, 90vh) !important;
  max-height: 90vh !important;
  margin-top: 5vh !important;
  margin-bottom: 0 !important;
  display: flex !important;
  flex-direction: column;
  overflow: hidden !important;
  border-radius: 12px;
}

.el-dialog.dept-config-dialog .el-dialog__header,
.dept-config-dialog .el-dialog__header {
  flex: 0 0 auto;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #eef0f3;
}

.el-dialog.dept-config-dialog .el-dialog__body,
.dept-config-dialog .el-dialog__body {
  flex: 1 1 auto !important;
  height: 0 !important;
  min-height: 0 !important;
  /* 四周留白，避免内容贴边；滚动条落在内层 content */
  padding: 12px 16px !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
}

.el-dialog.dept-config-dialog .el-dialog__footer,
.dept-config-dialog .el-dialog__footer {
  flex: 0 0 auto;
  padding: 12px 20px 16px;
  border-top: 1px solid #eef0f3;
  background: #fafbfc;
}

/* 兼容不支持 :has 的浏览器：按 custom-class 定位 wrapper 子节点 */
.el-dialog.dept-config-dialog {
  position: relative;
}

/* 手机端部门配置：仅保留固定高度壳；双栏/竖排由全局 admin-responsive 处理。最后修改：2026-09-15 */
@media screen and (max-width: 768px) {
  .el-dialog.dept-config-dialog,
  .dept-config-dialog {
    width: 96% !important;
    max-width: 96vw !important;
    height: calc(100vh - 4vh) !important;
    height: calc(100dvh - 4vh) !important;
    max-height: calc(100vh - 4vh) !important;
    max-height: calc(100dvh - 4vh) !important;
    margin-top: 2vh !important;
  }

  .el-dialog.dept-config-dialog .el-dialog__body,
  .dept-config-dialog .el-dialog__body {
    padding: 8px 10px !important;
  }
}
</style>